const companyName = import.meta.env.VITE_COMPANY_NAME_EN;

import errors from './api-errors/en.js';
import businessDirectory from './business-directory/en.js';
import logTemplates from './log-templates/en.js';
import permission from './permission/en.js';
// @ts-ignore
export default {
  ...errors,
  ...permission,
  ...businessDirectory,
  ...logTemplates,
  NavaTel: companyName,
  Navatel: companyName,
  navatel: companyName,
  logout: 'Logout',
  type: 'Type',
  service: 'Service',
  opps: 'Oops',
  thisPageYouAreLookingForCouldNotBeFound:
    'The page you are looking for could not be found',
  goBackToHome: 'Go back home',
  goBackToTicket: 'Go back tickets',
  goBackToLead: 'Go back leads',
  goBackToDeal: 'Go back deals',
  goBackToPeople: 'Go back people',
  goBackToCompanies: 'Go back companies',
  themeColor: 'Light theme',
  themeDarkColor: 'Dark theme',
  home: 'Home',
  userProfile: 'Agent profile',
  myProfile: 'My profile',
  noState: 'No state',
  accountSettings: 'Account settings',
  myInbox: 'My inbox',
  messagesEmails: 'Messages & emails',
  myTasks: 'My tasks',
  toDoAndDailyTasks: 'To-do & daily tasks',
  notifications: 'Notifications',
  seeAllNotifications: 'View all notifications',
  usersSettings: 'User settings',
  userManagement: 'User management',
  errorInUserManagement: 'Eror in user management',
  listOfUsers: 'Users list',
  roleManagement: 'Role management',
  messagesToOperators: 'Send Message to Users',
  crm: 'CRM',
  CRM: 'CRM',
  people: 'Contacts',
  companies: 'Companies',
  callSetting: 'Call settings',
  definitionCallForwardingNumber: 'Call forwarding number',
  uploadRecording: 'Upload recording',
  uploadDate: 'Upload date',
  format: 'Format',
  file: 'File',
  queue: 'Queue',
  queueManagement: 'Queue management',
  manageIvr: 'IVR management',
  noIvr: 'No IVR menu has been defined yet.',
  setTimeCondition: 'Set time conditions',
  manageVoicemail: 'Voicemail management',
  blackList: 'Blacklist',
  callDestination: 'Call destination',
  ratings: 'Call survey',
  monitoring: 'Monitoring',
  dashboard: 'Dashboard',
  wallboard: 'Wallboard',
  liveCall: 'Live calls',
  usersStatus: 'Users status',
  hangupReason: 'Call logs',
  answeredNumber: 'Number of answered calls',
  calls: 'Call status',
  missedNumber: 'Number of missed calls',
  totalCallDuration: 'Total call duration',
  totalMissedWaitngDuration: 'Total waiting time on missed calls',
  totalAnswereddWaitngDuration: 'Total waiting time on answered calls',
  operatorActivity: 'Agent performance',
  cdr: 'Call records',
  fullCdrs: 'Advanced call report',
  scatteirng: 'Call scatter chart',
  rating: 'Call survey results',
  cost: 'Cost',
  customerWaitChart: 'Customer wait chart',
  insertNewTicket: 'Create ticket',
  transferToAnotherOperator: 'Transfer to another agent',
  ticketAssignModalText: 'Ticket assignment successful.',
  transfer: 'Transfer',
  ticketsList: 'View sent tickets',
  ticketList: 'Ticket list',
  connectToCrm: 'Connect to CRM',
  crmNumbers: 'Define CRM numbers',
  crmStructure: 'CRM structure',
  CRMlinks: 'CRM links',
  noCrmSetting: 'No setting defined.',
  noCrmNumber: 'No number defined.',
  fax: 'Fax',
  insertNewFax: 'Create fax',
  faxDate: 'Fax Date',
  faxType: 'Fax Type',
  sendFax: 'Send fax',
  headNumber: 'Head Number',
  reportOfSubmittedFax: 'Sent faxes',
  reportOfReceivedFax: 'Received faxes',
  webchat: 'Web chat',
  insertNewWebsit: 'Add website',
  insertOperatorNumber: 'Add agent number',
  insertOperatorNumberTitle: 'Add agent number',
  manageOperator: 'Agents',
  manageOperatorTitle: 'Manage Operator',
  manageRoles: 'Role management',
  department: 'Department',
  definitionDepartments: 'Definition departments',
  enterDepartmentName: 'Enter department name.',
  customize: 'Settings & customization',
  noSite: 'No site available to configure.',
  conversations: 'Conversations',
  noItemExist: 'No items available for selection.',
  firstSelectWebsite: 'Please select a website first.',
  numberDeleteSuccessfully: 'Number deleted successfully.',
  createLinkGuid: 'Click to generate meeting link.',
  linkAddress: 'Link address',
  copyNotPossible: 'Copying not supported',
  linkType: 'Link type',
  meetTitle: 'Meeting title',
  meetParticipantsNumber: 'Number of participants',
  recordDeleteModalTitle: 'Delete record',
  videoConference: 'Video conference',
  createLinkTitle: 'Create link',
  products: 'Products',
  connectToWhatsapp: 'Connect to whatsapp',
  whatsappAccounts: 'Whatsapp accounts',
  whatsapp: 'Whatsapp',
  whatsappMessages: 'Whatsapp messaging',
  enterWhatsapp: 'Login to whatsapp',
  whatsappAdd: 'Create whatsapp account',
  whatsappAddAccount: 'Add whatsapp account',
  noAccountYet:
    'You have not added any whatsapp account yet! click below to add.',
  addWhatsAppAccount: 'Guide: click to add a new whatsapp account.',
  addWhatsAppAccountText: 'Add whatsapp account',
  countryCode: 'Country code',
  profileTitle: 'Profile title',
  profileTitlePlaceHolder: 'Enter desired title',
  lineNumber: 'Line number',
  enterYourWhatsappLine: 'Enter your whatsapp line number',
  crmContactUpdate: 'CRM contact update',
  contactAvatarUpdate: 'Update contact avatar',
  crmContactAutoCreate: 'Auto-create CRM contacts',
  samplePhone: '09129876543',
  optional: '(optional)',
  inactive: 'Inactive',
  connected: 'Connected',
  qrcodeScan: 'Scan qr code',
  whatsappconnect1: 'Open whatsapp on your phone.',
  whatsappconnect21: 'On menu',
  whatsappconnect22: 'Or settings',
  whatsappconnect23: 'Click',
  whatsappconnect3: 'Scan the code.',
  newCloseText: 'No, go back',
  newConfirmText: 'Yes, delete',
  whatsappdelete1: 'Are you sure to delete whatsapp account',
  whatsappdelete2: '?',
  whatsappcreatesuccess: 'Whatsapp account created successfully.',
  whatsappaccountmanagement: 'Whatsapp account management',
  newAccountAya: 'Do you want to create another account?',
  newAccount: 'Create new account',
  editConfirmed: 'Edit confirmed',
  samplePlaceHolder: 'Technical development department',
  receiver: 'Receiver',
  receiving: 'Receiving',
  whatsAppFileInputMessage: 'Only jpeg, png, SVG files up to 25mb.',
  productFileInputMessage: 'Only jpeg, png files up to 1mb.',
  enterMessageText: 'Enter your message!',
  messageText: 'Message text',
  sendWhatsappMessage: 'Send whatsapp message',
  draft: 'Draft',
  noWhatsAppMessageYet: 'No messages sent from this whatsapp account yet!',
  messageSentSuccessfully: 'Message sent successfully.',
  meetDate: 'Meeting date',
  meetDuration: 'Meeting duration',
  recordDeleteModalText: 'Are you sure you want to delete this record?',
  meetListPageTitle: 'Event list',
  writeDown: 'Write your message...',
  chatPage: 'Chat page',
  willScanLater: 'Scan later',
  deleteWhatsappNumber: 'Delete whatsapp account',
  history: 'History',
  productHistory: 'Product history',
  createLink: 'Create link',
  linkTitle: 'Meeting title',
  invoicePreInvoice: 'Invoice / Preinvoice',
  invoiceAndPreInvoice: 'Invoice and preinvoice',
  invoice: 'Invoice',
  preinvoice: 'Preinvoice',
  preInvoice: 'PreInvoice',
  documentNumber: 'Document number',
  documentType: 'Document type',
  customerType: 'Customer type',
  expirationDate: 'Expiration date',
  paymentDate: 'Payment date',
  documentDate: 'Document date',
  price: 'Amount',
  addInvoiceText:
    'No invoice or preinvoice created yet. click below to create one.',
  addPreinvoiceText: 'Click below to create a preinvoice.',
  notFoundInvoice: 'No invoice or preinvoice found with the entered details.',
  preinvoiceCurrency: 'Preinvoice currency',
  invoiceCurrency: 'Invoice currency',
  noInvoiceSubmittedForThisProfile: 'No Invoice Submitted for This Profile',
  naturalis: 'Individual',
  juridica: 'Corporate',
  telephone: 'Phone',
  productName: 'Product name',
  unitPrice: 'Unit price',
  count: 'Count',
  discountType: 'Discount type',
  amount: 'Amount',
  discount: 'Discount',
  tax: 'Tax & fees',
  totalPrice: 'Total price',
  percentage: 'Percentage',
  preinvoiceDescription: 'Preinvoice description',
  finalPrice: 'Final amount',
  totalDiscount: 'Total discount',
  totalTax: 'Total tax & fees',
  otherCosts: 'Other costs',
  addNewRow: 'Add new row',
  amountToPay: 'Amount to pay',
  amountToPayNumber: 'Amount to pay (numeric)',
  amountToPayWord: 'Amount to pay (in words)',
  revocation: 'Revocation',
  revocationed: 'Canceled',
  convertToInvoice: 'Convert to invoice',
  advanceInvoices: 'Preinvoices',
  deletePreinvoice: 'Delete preinvoice',
  deleteInvoice: 'Delete invoice',
  deletePreinvoiceText: 'Are you sure you want to delete preinvoice {item}?',
  deleteInvoiceText: 'Are you sure you want to delete invoice {item}?',
  deletePreinvoiceSuccessfully: 'Preinvoice invoice deleted successfully',
  deleteInvoiceSuccessfully: 'Invoice deleted successfully',
  revocationText: 'Are you sure to cancel invoice {item}?',
  revocationNoteText:
    'Canceling an invoice means refunding the payment to the customer.',
  preinvoiceNumber: 'Preinvoice number',
  invoiceNumber: 'Invoice number',
  expirationDuration: 'Expiration period',
  expirationDurationText: '{day} days after sending the preinvoice',
  saveDraft: 'Save as draft',
  billingPreInvoice: 'Send preinvoice',
  billing: 'Send invoice',
  saveInvoice: 'Save invoice',
  saveAndSendInvoice: 'Save & send invoice',
  sureToSaveAndSendInvoice:
    'Are you sure you want to save and send the invoice?',
  sureToSaveInvoice: 'Are you sure you want to save the invoice?',
  canNotUpdateInvoice: 'Note: you cannot edit the invoice after saving.',
  yesSaveAndSend: 'Yes, save & send',
  yesSave: 'Yes, save',
  preinvoiceSaveToDraftSuccessfully:
    'Preinvoice invoice saved to draft successfully.',
  invoiceSavedSuccessfully: 'Invoice saved successfully',
  preInvoiceSavedSuccessfully: 'Preinvoice saved successfully',
  invoiceSendSuccessfully: 'Invoice sent successfully',
  preinvoiceRevocationSuccessfully: 'Invoice canceled successfully.',
  invoiceHistory: 'Invoice history',
  preinvoiceHistory: 'Preinvoice history',
  factorSearchText: 'Search by document number, customer name',
  invoiceAndPreinvoiceSetting: 'Invoice & Preinvoice settings',
  template: 'Template',
  advanceSetting: 'Advanced settings',
  ecoNumber: 'Economic code',
  enterYourAddress: 'Enter address',
  saveSettings: 'Save settings',
  vertical: 'Vertical',
  horizontal: 'Horizontal',
  displayType: 'Display type',
  uploadCompanyLogo: 'Upload company logo',
  uploadBackground: 'Upload watermark image',
  uploadStampAndSignature: 'Upload stamp & signature',
  distanceFromTop: 'Margin from top (px)',
  distanceFromBottom: 'Margin from bottom (px)',
  distanceFromRight: 'Margin from right (px)',
  distanceFromLeft: 'Margin from left (px)',
  displayLogoOnPreinvoice: 'Show logo on preinvoice',
  displayLogoOnInvoice: 'Show logo on invoice',
  displayStampAndSignatureOnPreinvoice: 'Show seal & signature on preinvoice',
  displayStampAndSignatureOnInvoice: 'Show seal & signature on invoice',
  displayBackgroundInPreinvoice: 'Show watermark on preinvoice',
  displayBackgroundInInvoice: 'Show watermark on invoice',
  preinvoiceNumberFormat: 'Preinvoice number format',
  invoiceNumberFormat: 'Invoice number format',
  preinvoiceStartingNumber: 'Preinvoice starting number',
  invoiceStartingNumber: 'Invoice starting number',
  defaultTax: 'Default tax percentage',
  showTaxColumn: 'Show tax column',
  showProductCode: 'Show product code',
  displayCountAndAmountOfUnits: 'Display quantity & unit amount',
  showDiscountColumn: 'Show discount column',
  createQrInPdf: 'Generate qr in PDF',
  invoiceDescription: 'Invoice description',
  sendInWhatsapp: 'Send via whatsapp',
  copyLinkAndDownloadPDF: 'Copy link & download PDF',
  sendBySMS: 'Send via SMS',
  downloadPdfFile: 'Download PDF file',
  textCopySuccessfully: 'Text copied successfully',
  linkCopySuccessfully: 'Link copied successfully',
  enterSmsText: 'Enter SMS text',
  logo: 'Logo',
  preinvoiceDate: 'Preinvoice date',
  invoiceDate: 'Invoice date',
  seller: 'Vendor',
  buyer: 'Buyer',
  productNameAndCode: 'Product name & code',
  discountPrice: 'Discount amount',
  totalAmountAfterDiscount: 'Total amount after discount',
  total: 'Total',
  stampAndSignature: 'Stamp & signature',
  backgroundImage: 'Background image',
  invoiceSetting: 'Invoice settings',
  convertToFactorText: 'Are you sure to convert preinvoice {item} to invoice?',
  convertToInvoiceText:
    'Converting a preinvoice to an invoice means the customer will pay the amount.',
  preinvoiceConvertToInvoiceSuccessfully:
    'Preinvoice successfully converted to invoice.',
  title: 'Title',
  dataIsIncorrect: 'Entered data is incorrect',
  onlyPngFilesAreAllowed: 'Only PNG files are allowed.',
  sendLink: 'Send link',
  fileToBeUploaded: 'File to be uploaded',
  performanceEvaluation: 'Performance review',
  savePerformanceEvaluation: 'Performance Review',
  saveEvaluation: 'Save evaluation',
  performanceEvaluationReport: 'Performance evaluation report',
  seccode: 'Seccode',
  secretCode: 'Secret code',
  signInNavatel: `Sign in to ${companyName}`,
  username: 'Username',
  password: 'Password',
  rememberMe: 'Remember me',
  forgetPassword: 'Forgot password',
  login: 'Login',
  invalidUsernameOrPassword: 'Invalid username or password.',
  enterTheCerificationCode: 'Enter the Verification Code',
  enterTheCodeSentToNavatelNumberBelow:
    'Enter the code sent to Navatel number <span>{number}</span> below.',
  resendAfter: 'Resend after:',
  resendCode: 'Resend code',
  didntGetTheCode: "Didn't receive the code?",
  confirmDeletionOfRecords: 'Confirm Deletion of Records',
  otpHasBeenSentToTheAdminToPerformThisOperation:
    'OTP has been sent to the admin to perform this operation',
  byConfirmingThisCodeTheConversationRecordsInTheSelectedRangeWillBePermanentlyDeleted:
    'By confirming this code, the conversation records in the selected range will be permanently deleted',
  forgotPassword: 'Forgot your password?',
  forgotPasswordGuide: `Please enter your ${companyName} number below. We will send a password reset link to your ${companyName}.`,
  numberInNavatel: `Phone number in ${companyName} app`,
  enterYourNavatel: `Enter your ${companyName} number`,
  backToLogin: 'Back to login',
  notFoundNumber: 'Number not found',
  linkSendSuccessfully: 'Link sent successfully',
  resetPassword: 'Reset password',
  resetPasswordGuide: 'Enter your new password to access your account.',
  enterYourNewPassword: 'Enter your new password',
  confirmPassword: 'Confirm password',
  updatePasswordSuccessfully: 'Password updated successfully.',
  uploadFile: 'Upload file',
  recordingName: 'Call recording name',
  play: 'Play',
  uploadRecordingGuide:
    'File size must not exceed 5mb. file format must be MP3 or wav.',
  fileIsRequired: 'File selection is required.',
  fileSizeShouldBeLessThan: 'File size must be less than {size}.',
  recordingUploadSuccessfully: 'Recording uploaded successfully.',
  deleteRecording: 'Delete call recording',
  deleteRecordingText: 'Are you sure you want to delete call recording {item}?',
  recordingDeleteSuccessfully: 'Call recording deleted successfully.',
  recording: 'Call recording',
  fileSizeWarning:
    'File size must not exceed 5mb. file format must be MP3 or wav.',
  enterSearchKey: 'Enter keyword to search',
  newUser: 'New User',
  chooseStateFirst: 'Please select a state first',
  contactInformation: 'Contact information',
  outOfToken: 'Your tokens have run out. please recharge your panel.',
  dataInsertSuccessfully: 'Data inserted successfully',
  dataUpdateSuccessfully: 'Data updated successfully',
  sureToCall: 'Make call',
  sureToCallText: 'Are you sure to make a call to {item}?',
  acceptCall: 'Yes, make call',
  peopleGuide: 'Guide: click "add new person" to define a person profile.',
  createDate: 'Creation date',
  datePeriod: 'Date period',
  percentageOfTotal: 'Percentage of total',
  selectCreateDate: 'Select Create Date',
  row: 'Row',
  return: 'Back',
  fieldsAreOptional: 'The following fields are optional.',
  editCompanyInformation: 'Edit Company Information',
  companyInformation: 'Company information',
  companiesGuide: 'Guide: click "add new company" to define a company profile.',
  faxNumber: 'Fax number',
  headOfFaxNumber: 'Head of Fax Number',
  selectHeadOfFaxNumber: 'Select Head of Fax Number',
  creatHeadOfFaxNumber: 'Create Head of Fax Number',
  editHeadOfFaxNumber: 'Edit Head of Fax Number',
  agentFullname: 'Agent full name',
  agentName: 'Agent Name',
  agentFamily: 'Agent Family Name',
  personInformation: 'Person information',
  mainInformation: 'Main information',
  ContactInformation: 'Contact Information',
  profileInformation: 'Profile information',
  personalInformation: 'Personal information',
  agentInformation: 'Agent information',
  mainPhoneNumber: 'Main phone number',
  subscribeInformation: 'Subscription information',
  inputMedia: 'Source channel',
  contactStatus: 'Contact status',
  leadStatus: 'Lead status',
  buyingChances: 'Purchase probability',
  estimatedPurchaseAmount: 'Estimated purchase amount',
  resultOfLastConnection: 'Last contact result',
  dateOfLastConnection: 'Date of last connection',
  AddDateOfLastConnection: 'Add date of last connection',
  lastConnection: 'Latest Connection',
  followUpOperator: 'Owner agent',
  acceptEdit: 'Accept edit',
  nationalCode: 'National code',
  companyName: 'Company name',
  businessName: 'Business name',
  businessInformation: 'Business information',
  companyNationalId: 'National ID',
  major: 'Field of activity',
  ecoCode: 'Economic code',
  uniqueCode: 'Unique code',
  myCompanyNumber: `My ${companyName} Number`,
  whatsappNumber: 'Whatsapp number',
  telegramNumber: 'Telegram number',
  instagram: 'Instagram',
  likedin: 'LinkedIn',
  landlinePhone: 'Landline phone',
  profileCreationDate: 'Profile creation date',
  gender: 'Gender',
  birthday: 'Date of birth',
  state: 'State',
  city: 'City',
  address: 'Address',
  postalCode: 'Postal code',
  activities: 'Activities',
  interactions: 'Interactions',
  task: 'Task',
  responsible: 'Responsible',
  responsiblePlaceholder: 'Default follow-up agent',
  creatTask: 'Create task',
  taskTitle: 'Task title',
  taskType: 'Task type',
  doneDate: 'Completion date',
  deadline: 'Deadline',
  setDeadline: 'Set Deadline',
  inConnectionWith: 'In connection with',
  timeRemember: 'Reminder time',
  telegram: 'Telegram',
  sms: 'SMS',
  mobileNumber: 'Mobile number',
  sentSmsList: 'Sent SMS list',
  selectOriginNumber: 'Select origin number',
  selectDestinationNumber: 'Select Destination Number',
  smsText: 'Sms text',
  smsSubject: 'Sms subject',
  smsType: 'Sms type',
  enterYourText: 'Enter your text',
  avatar: 'Avatar',
  selectYourFile: 'Select file',
  selectYourFilePngFormat: 'Select file (png format)',
  addContact: 'Add contact',
  deleteContact: 'Delete contact',
  contactNumberSearch: 'Search by contact number',
  subjectOrSmsTextSearch: 'Search by subject or SMS text',
  deleteContactText: 'Are you sure you want to delete contact {item}?',
  contactDeleteSuccessfully: 'Contact deleted successfully.',
  contactInsertSuccessfully: 'Contact added successfully.',
  contactUpdateSuccessfully: 'Contact updated successfully.',
  allCalls: 'All calls',
  missedCall: 'Missed call',
  missed: 'Missed',
  nextFollowUpDate: 'Next follow-up date',
  reminder: 'Reminder',
  reminderTime: 'Select reminder date',
  noReminder: 'No reminder',
  noType: 'No Type',
  noAssignee: 'No Assignee',
  minutesAgo: '{item} minutes ago',
  hoursAgo: '{item} hours ago',
  daysAgo: '{item} days ago',
  atFollowUp: 'At follow-up time',
  reason: 'Reason',
  reasonsForCalling: 'Call description',
  addCallReason: 'Add call description',
  callReason: 'Call description',
  callId: 'Call ID',
  callReasonInsertSuccessfully: 'Call description added successfully',
  callToLanding: 'Call landline',
  callToMain: 'Call main number',
  jobPosition: 'Position',
  note: 'Note',
  submitNote: 'Submit note',
  insertNote: 'Add note',
  createNote: 'Create note',
  noteTitle: 'Note title',
  editNote: 'Edit note',
  enterNoteText: 'Enter note text!',
  identityDocuments: 'Identity documents',
  upload: 'Upload',
  uploadIdentityDocuments: 'Upload identity documents',
  editIdentityDocuments: 'Edit identity documents',
  uploadAttachments: 'Upload attachments',
  editAttachments: 'Edit attachments',
  documentTitle: 'Document name',
  documentFile: 'Document file',
  attachment: 'Attachment',
  attachments: 'Attachments',
  deleteFile: 'Delete file',
  deleteFileText: 'Are you sure you want to delete file {item}?',
  fileDeleteSuccessfully: 'File deleted successfully.',
  fileInserSuccessfully: 'File added successfully.',
  fileUpdateSuccessfully: 'File updated successfully.',
  noteDeleteSuccessfully: 'Note deleted successfully.',
  noteInsertSuccessfully: 'Note added successfully.',
  noteUpdateSuccessfully: 'Note updated successfully.',
  calling: 'Calling...',
  rial: 'Rial',
  excel: 'Excel',
  downloadExcelFile: 'Download excel file',
  exportWithFilters: 'Export with the following filters',
  advanceFilter: 'Advanced filter',
  doDelete: 'Clear',
  clear: 'Clear',
  clearAll: 'Clear All',
  past: 'Past',
  yesterday: 'Yesterday',
  today: 'Today',
  day: 'Day',
  tomorrow: 'Tomorrow',
  future: 'Future',
  sendMessage: 'Sent message',
  reciveMessage: 'Received message',
  comments: 'Comments',
  addComment: 'Add comment',
  closeComment: 'Close Comment',
  onlineChat: 'Online chat',
  typing: 'Typing...',
  recordingVoice: 'Recording voice...',
  sendingFile: 'Sending file...',
  picture: 'Picture',
  mapLocation: 'Location',
  selectYourLocation: 'Select Your Location',
  audioFile: 'Audio File',
  videoRecord: 'Video Record',
  video: 'Video',
  camera: 'Camera',
  downloadFailed: 'Download Failed',
  queueGuide: 'Guide: here you can create queues (internal agents).',
  insertQueue: 'Create queue',
  extention: 'Extension {text}',
  insertQueueCallcenter: 'Create call center queue',
  selectStrategy: 'Select ring strategy',
  callAllOperators: 'Ring all agents',
  ringAll: 'Ring all agents',
  roundRobinAlgorithm: 'Random (round robin algorithm)',
  roundRobin: 'Random (round robin algorithm)',
  orderWithMinCall: 'Agent with minimum calls',
  operatorWithMinTalkTime: 'Agent with minimum talk time',
  agentWithLeastTalkTime: 'Agent with least talk time',
  orderOfOperators: 'By agent order',
  topDown: 'By agent order',
  selectWaitingVoice: 'Select queue hold tone',
  waitingVoice: 'Queue hold tone',
  maxWaitingTime: 'Max waiting time',
  maxWaitingTimeAnyOperatorAvailable:
    'Max waiting time when no agent is available',
  maxWaitingTimeNoOperatorAvailable: 'Max waiting time when agent unavailable',
  actionForExpiredQueueTime: 'Select action after queue waiting time expires',
  activateCallRecording: 'Enable call recording',
  expiredQueueTime: 'When queue waiting time expires',
  activatePollingOfIncomingCalls: 'Enable inbound call polling',
  hideCallerIdOfIncomingCall: 'Hide caller ID for inbound calls in queue',
  callerId: 'Caller ID',
  numberOfPeopleWaiting: 'Announce number of people in queue',
  waitingTimeInQueue: 'Announce waiting time in queue',
  leavingQueueAndGoBack: 'Allow leaving queue and returning',
  endConversation: 'End conversation',
  areYouSureThisConversationIsOver: 'are you sure this conversation is over?',
  selectEndReason: 'Select end reason',
  leaveKey: 'Queue exit key',
  noQueue: 'No queue created yet.',
  leaveAction: 'Select action when leaving queue',
  active: 'Active',
  deactive: 'Inactive',
  all: 'All',
  queueInsertSuccessfully: 'Queue added successfully.',
  queueUpdateSuccessfully: 'Queue updated successfully.',
  deleteQueue: 'Delete queue',
  deleteQueueText: 'Are you sure you want to delete queue {item}?',
  queueDeleteSuccessfully: 'Queue deleted successfully.',
  addOperatorToQueue: 'Add agent to call center',
  addOperatorToQueueTitle: 'Click green tick to add agent',
  addOperatorToQueueText:
    "To set agent ring order after choosing 'agent order', rearrange rows.",
  thisCallNotForYou: 'This call is not for you',
  ivrGuide: 'Guide: add IVR menu for extensions and upload audio files.',
  insertIvr: 'Create IVR menu',
  internalId: 'Internal ID',
  minutesSeconds: '(minutes/seconds)',
  selectRecordingFile: 'Select recording file',
  durationConnectionOperator: 'Duration connected to agent',
  durationConnectionPreviousOperator:
    'Duration to keep connected to previous agent (minutes)',
  connectCallToPreviousOperator: 'Connect call to previous agent',
  selectActionIvrFinished: 'Select action after IVR ends',
  addExtention: 'Add extension',
  addVipExtention: 'Add vip extension',
  ivrInsertSuccessfully: 'IVR added successfully.',
  ivrUpdateSuccessfully: 'IVR updated successfully.',
  deleteIvr: 'Delete IVR',
  deleteIvrText: 'Are you sure you want to delete IVR {item}?',
  ivrDeleteSuccessfully: 'IVR deleted successfully.',
  callDestinationGuide: 'Guide: select action to receive calls.',
  channelName: 'Channel name',
  channel: 'Channel',
  wallet: 'Balance',
  numberOfCalls: 'Total calls',
  numberOfCall: 'Number of calls',
  enterpriseDid: 'Inbound',
  enterpriseOut: 'Outbound',
  incoming: 'Inbound',
  outgoing: 'Outbound',
  answeredIncomingCall: 'Answered inbound calls',
  answeredOutgoingCall: 'Answered outbound calls',
  unansweredIncomingCall: 'Unanswered inbound calls',
  unansweredOutgoingCall: 'Unanswered outbound calls',
  timeOfOutgoingCalls: 'Outbound call minutes',
  timeOfIncomingCalls: 'Inbound call minutes',
  averageWaitingTime: 'Average waiting time',
  minWaitingTime: 'Min waiting time',
  averageTalkTime: 'Average talk time',
  maxTalkTime: 'Max talk time',
  minTalkTime: 'Min talk time',
  averageIncomingTalkTime: 'Average inbound talk time',
  averageOutTalkTime: 'Average outbound talk time',
  costOfCalls: 'Call costs',
  asr: 'Service level',
  cloudMemory: 'Cloud storage',
  totalMemory: 'Total storage',
  remainingMemory: 'Remaining storage',
  usedMemory: 'Used storage',
  mb: 'Mb',
  version: 'Version',
  totalIncomingCall: 'Total inbound calls',
  totalOutgoingCall: 'Total outbound calls',
  operatorAvailableToCall: 'Agents available for call',
  totalCustomersInIvr: 'Customers in IVR',
  numberOfIncomingCallsAnswered: 'Answered inbound calls',
  numberOfOutgoingCallsAnswered: 'Answered outbound calls',
  numberOfSimultaneousCalls: 'Simultaneous calls',
  inUse: 'Busy',
  free: 'Available',
  totalCustomersInQueue: 'Customers in queue',
  numberOfIncomingCallsDropped: 'Inbound calls dropped (by customer)',
  byCustomer: '(by customer)',
  numberOfOutgoingUnansweredCalls: 'Unanswered outbound calls',
  theNumberOfOperatorsInConversation: 'Agents in conversation',
  pollScore: 'Survey score',
  numberOfIncomingUnansweredCalls: 'Unanswered inbound calls',
  numberOfIncomingCalls: 'Inbound calls',
  numberOfOperatorsToAnswer: 'Agents available to answer',
  numberOfOperatorsInIncomingConversation: 'Agents in inbound conversation',
  numberOfSimultaneousIncomingCalls: 'Simultaneous inbound calls',
  AverageIncomingTalkTime: 'Average inbound talk time',
  fullScreen: 'Full screen',
  origin: 'Origin',
  destination: 'Destination',
  waitingTimePlaceholder: 'Waiting time',
  callDuration: 'Call duration',
  whisper: 'Whisper',
  callControl: 'Listen',
  enterConversation: 'Barge-in',
  waitingForCall: 'Waiting for call',
  outgoingCall: 'Outgoing call',
  incomingCall: 'Incoming call',
  inOutgoingCall: 'In outbound call',
  userName: 'Agent name',
  userNumber: 'Agent number',
  userStatus: 'Agent status',
  statusDuration: 'Status duration',
  changeOperatorStatus: 'Are you sure to change agent status?',
  rest: 'Break',
  available: 'Available',
  launch: 'Lunch',
  arrest: 'Leave',
  holiday: 'Holiday',
  inMeeting: 'Meeting',
  faxInsertGuide:
    "Guide: to create and send fax, click 'create fax' and enter your email.",
  identerUniqeNumber: 'Enter a unique number for id.',
  enterYourEmail: 'Enter your email',
  faxInsertSuccessfully: 'Fax added successfully.',
  faxUpdateSuccessfully: 'Fax updated successfully.',
  deleteFaxFile: 'Delete fax file',
  deleteFaxFileText:
    'Are you sure you want to delete the fax file with ID {item}?',
  deleteFax: 'Delete fax',
  deleteFaxText: 'Are you sure you want to delete fax {item}?',
  faxDeleteSuccessfully: 'Fax deleted successfully',
  emailAddress: 'Email address',
  selectOrigin: 'Select origin',
  destinationNumber: 'Destination number',
  destinationInternalNumber: 'Destination internal number (optional)',
  tryToSend: 'Number of send attempts',
  selectPdf: 'Select PDF file',
  selectFile: 'Select file',
  dragAndDrop: 'Drag and drop your file here',
  or: 'Or',
  faxSendSuccessfully: 'Fax sent successfully',
  faxSenderNumber: 'Fax sender number',
  receivedDate: 'Received date',
  receivedTime: 'Received time',
  status: 'Status',
  recieveStatus: 'Receive status',
  success: 'Success',
  successCount: 'Success count',
  failed: 'Failed',
  failedCount: 'Failed count',
  totalCreatedAmount: 'Total created amount',
  totalSuccessAmount: 'Total success amount',
  totalFailedAmount: 'Total failed amount',
  theCodeEnteredIsInvalid: 'The Code Entered Is Invalid',
  fileUnavailable: 'File is not available.',
  faxFileDeleteSuccessfully: 'Fax file deleted successfully',
  next: 'Next',
  previous: 'Previous',
  faxRecieverNumber: 'Fax receiver number',
  sendDate: 'Send date',
  departmentguid:
    "Guide: use 'create department' to set up teams with different expertise and assign agents to each.",
  createdepartment: 'Add department',
  queueName: 'Queue name',
  queueDescription: 'Description',
  deletedepartment: 'Delete department',
  editdepartment: 'Edit department',
  willdeletedepartment: 'Are you sure you want to delete department {item}?',
  addAgentToQueModalTitle: 'Agents',
  clickToAddAgent: 'Click the green checkbox to add an agent',
  noAgentForSelectedOperator: 'No agents available for this department',
  enterDescription: 'Please enter a description!',
  changeAgentsOfDepartment: 'Department agents updated successfully.',
  websitelist: 'Website list',
  websitelistguid:
    "Guide: here you can view the website list and get each website's unique snippet code.",
  addwebsite: 'Add website',
  enterurlhereexample: 'Please enter the website URL.',
  example: 'Example: {item}',
  websitename: 'Website name',
  enterSiteName: 'Enter your website name',
  websiteaddress: 'Website address',
  selectWebsite: 'Select website',
  activation: 'Activation',
  guide: 'Guide',
  websiteInsertSuccessfully: 'Website added successfully.',
  websiteUpadatedSuccessfully: 'Website updated successfully.',
  getcode: 'Get snippet code',
  addcodetoheader:
    "Please add the snippet code to the website's <head> section.",
  setwebsitecode: 'Install snippet on website',
  snippetcode: 'Snippet code',
  copyCode: 'Copy snippet code',
  copy: 'Copy',
  close: 'Close',
  websitecodeguide:
    "Guide: place the generated snippet code in the website's <head> section.",
  textcopied: 'Text copied',
  operatorRegister: 'Register agent number',
  operatorNubmber: 'Agent number',
  operatorRegisterModalGuide: `Enter a number that has an account on ${companyName} messenger and verify it using the confirmation code sent by ${companyName}.`,
  operatorRegisterGuide: `Guide: add a number with the ${companyName} app and activate it using the save button.`,
  operatorRegisterPlaceHolder: 'Enter mobile number starting with 98',
  operatorRegisterButtonTitle: 'Add agent number',
  confirmNumber: 'Confirm number',
  verifyCode: 'Verification code',
  operationDone: 'Operation completed successfully',
  webChatOperatorsNumbers: "Web chat agents' numbers",
  numberDeleteModalTitle: 'Delete number',
  numberDeleteModalText: 'Are you sure you want to delete number {item}?',
  manageOperatorGuid:
    'Guide: complete this section to set access levels and create agents for agents.',
  addUserOperator: 'Add agent',
  registerOperator: 'Register agent number',
  selectNumbers: 'Select numbers',
  dashboardwebchat: 'Dashboard',
  dashboardwebchatguidtext: 'Messages sent and received per agent account',
  selectedOperator: 'Selected agents',
  operatorAcceessLevel: 'Agent access level',
  manageRoleGuid: 'Guide: you can define access levels for agent roles.',
  whatoperatoraccesses:
    'What access should agents have in your web chat system?',
  enterRoleName: 'Enter role name',
  addOperator: 'Add agent',
  editOperator: 'Edit agent',
  others: 'Others',
  roleNameDuplicate: 'Role name already exists.',
  fromDate: 'From date',
  toDate: 'To date',
  doSelect: 'Select',
  phoneNumber: 'Phone number',
  navatelPhoneNumber: 'Navatel number',
  search: 'Search',
  recentSearches: 'Recent searches',
  recentResults: 'Recent results',
  audience: 'Audience',
  taskCode: 'Task code',
  productCode: 'Product code',
  sourceChannelId: 'Source channel ID',
  doSearch: 'Do search',
  noRecord: 'No records found',
  loadingTableText: 'Please wait',
  opratorNumber: 'Agent number',
  enterNumber: 'Enter number',
  save: 'Save',
  editSubmit: 'Edit & submit',
  withdrawal: 'Cancel',
  no: 'No',
  ok: 'Ok',
  submitOtp: 'Send verification code',
  confirm: 'Confirm',
  continue: 'Continue',
  canNotConnectToService: 'Cannot Connect to Service',
  canNotConnectToServer: 'Unable to connect to server',
  actionDoSuccessfully: 'Action completed successfully.',
  commentSuccessfullySubmited: 'Comment successfully submited.',
  commentSuccessfullyEdited: 'Comment successfully edited.',
  deleteItemText: 'Are you sure you want to delete {item}?',
  deleteItem: 'Delete',
  edit: 'Edit',
  usersList: 'Agents list',
  fileUpload: 'Upload file',
  view: 'View',
  pause: 'Pause',
  copyLink: 'Copy link',
  enteringMeeting: 'Joining meeting',
  preview: 'Preview',
  information: 'Information',
  fromdate: 'From date',
  todate: 'To date',
  phonenumber: 'Phone number',
  norecord: 'No records found',
  noReports: 'No reports found!',
  loadingtableText: 'Loading...',
  callType: 'Call type',
  queuename: 'Queue name',
  operatorId: 'Agent ID',
  operatorType: 'Agent type',
  ClickOnRegistrationOfOperatorNumber:
    "Guide: to define your call center agent, click 'register agent number' and select the agent type.",
  registrationOfOperatorNumber: 'Register agent number',
  registrationOfOperator: 'Register agent',
  OperatorType: 'Operator',
  operator: 'Agent',
  callcenterOperator: 'Call center agent',
  family: 'Last name',
  number: 'Number',
  fullname: 'Full name',
  enterFullname: 'Enter full name',
  navatelUser: `${companyName} agent`,
  navatelUsersusernamePassword: `${companyName} agents (username & password)`,
  ipPhone: 'Ip phone',
  userRegistrationWithMobileNumber: 'Register agent with mobile number',
  userRegistrationWithUsernameAndPassword:
    'Register agent with username & password',
  ipPhoneUserRegistration: 'Register ip phone agent',
  withMobileNumber: 'With mobile number',
  mobilenumber: 'Mobile number',
  withUsernameAndPassword: 'With username & password',
  withIpPhone: 'With ip phone',
  enterYourNumberWith98: 'Enter your mobile number starting with country code',
  usernameenterYourNumberWith98:
    'Username (enter your mobile number starting with country code)',
  englishLowercaseLettersAndNumbers:
    'Password must include lowercase letters and numbers',
  thePasswordMustContainLowerCaseEnglishLettersAndNumbers:
    'Password must include lowercase letters and numbers',
  enterTheVerificationCode: 'Enter the verification code',
  navatelNumberConfirmation: `${companyName} number confirmation`,
  confirmationAndFinalRegistrationOfNavatelNumberEnterTheConfirmationCodeSentToTheDesiredNumberInNavatelMessenger: `Confirm and finalize ${companyName} number registration - enter the verification code sent to your number in ${companyName} messenger`,
  nnavanumberInsertSuccessfully: `${companyName} agent information successfully registered`,
  nnavanumberDeleteSuccessfully: `${companyName} agent information successfully deleted`,
  nnavanumberUpdateSuccessfully: `${companyName} agent information successfully updated`,
  navaaccountInsertSuccessfully: `${companyName} agent information successfully registered`,
  navaaccountDeleteSuccessfully: `${companyName} agent information successfully deleted`,
  accountInsertSuccessfully:
    'Ip phone agent information successfully registered',
  accountDeleteSuccessfully: 'Ip phone agent information successfully deleted',
  deleteOperatorTitle: 'Delete agent',
  deleteOperatorText: 'The agent will be deleted. are you sure?',
  areYouSureYouWantToDeleteUser:
    'Are you sure you want to delete agent {item}?',
  areYouSureYouWantToDeleteRole:
    'Are you sure you want to delete role "<b>{text}</b>"?',
  yesDelete: 'Yes, delete',
  allOperators: 'All agents',
  operators: '{text} agents',
  systemSettings: 'System settings',
  onlineConversationTitle: 'Online chat box title:',
  onlineConversationTitlePlaceholder:
    'Name displayed to agents when clicking on the chat box',
  welcomeMessage: 'Welcome message',
  welcomeMessagePlaceholder:
    'Default text displayed when opening the online chat page',
  beginningMessage: 'Start message',
  beginningMessagePlaceholder:
    'Automated message sent to initiate conversation with the customer',
  popupContent: 'Popup content:',
  popupContentPlaceholder: 'Popup text',
  popupTitle: 'Popup title:',
  popupTitlePlaceholder: 'Popup title',
  operatorResponseStrategy: 'Agent response strategy',
  replacementonthesite: 'Replacement on the site:',
  leftMargin: 'Left margin:',
  rightMargin: 'Right margin:',
  bottomMargin: 'Bottom margin:',
  choosePhoto: 'Choose photo:',
  onlineConversationLanguage: 'Online chat language',
  chooseColor: 'Choose color:',
  chooseColorPlaceHolder: 'Choose color:',
  departmentText: 'Default department selection text',
  submitSettings: 'Submit settings',
  deleteRoleText: 'Are you sure you want to delete role {item}?',
  baseInformation: 'Basic information',
  templateAndColors: 'Template & colors',
  makeForm: 'Create form',
  timeConditions: 'Time conditions',
  learnBot: 'Chatbot training',
  modalTitle: 'Modal title',
  statusIndicator: 'Status indicator',
  enterStartMessage: 'Enter the start message!',
  startTextHint:
    'The first message automatically sent to the recipient by the system.',
  guideText: 'Guide text',
  enterWelcomeText: 'Enter welcome message!',
  enterGuideText: 'Enter guide text!',
  showQuestionsFirst: 'Show FAQ first.',
  enteringPhonenumberIsRequired: 'Phone number entry is required.',
  uploadLogo: 'Upload logo',
  uploadAvatar: 'Upload avatar',
  logoHint: 'Recommended size: 20x20 px, PNG format.',
  defaultLogo: 'Default logos',
  defaultAvatar: 'Default avatars',
  showInWebsite: 'Show on website',
  onlyMainPage: 'Main page only',
  allPages: 'All pages',
  showInMobile: 'Show on mobile',
  selectTheme: 'Select color theme',
  selectCustomTheme: 'Select custom color',
  copyRightNavatel: 'Designed and implemented by Navatel',
  createFormAs: 'Create form as',
  integrate: 'Integrated',
  everyDepartment: 'Every department',
  questionNumber: 'Faq number {number}',
  answereNumber: 'Faq answer number {number}',
  addQuestion: 'Add FAQ',
  addQuestionDepartment: 'Add department faqs',
  questionListUpdate: 'Faq list updated successfully',
  showPopup: 'Show popup',
  normalDays: 'Regular days',
  specialDays: 'Special days',
  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  workingDay: 'Working day',
  vacation: 'Holiday',
  webchatInVacation: 'Web chat status on holidays',
  webchatInSpecial: 'Web chat status on special days',
  offlineMessage: 'Offline message',
  sendSmartMessage: 'Send smart message',
  sendToWhatsapp: 'Send messages to whatsapp',
  hideChatBox: 'Hide chat box during non-working hours',
  disableChat: 'Disable chat',
  offlineMessageText:
    'After entering information, the recipient receives a message based on off-hours',
  enterMessage: 'Enter message',
  addSpecialDay: 'Add special day',
  clickToAddSpecialDay: 'Click below to add special days.',
  crmNumbersTitle: 'Define authorized CRM numbers',
  crmNumbersGuidNoNum:
    'No numbers have been added yet. use the add button to add.',
  crmGuidNumbers:
    'Guide: enter the agent number to connect agents for CRM settings.',
  crmNumberAddButton: 'Add',
  crmNumberReturnButton: 'Return',
  crmContactNumber: 'Contact number',
  crmAddModalText: 'Enter the number with country code without leading zero.',
  crmTypeTitle: 'Selected CRM type:',
  crmUrl: 'URL:',
  crmUrlPlaceholder: 'URL',
  crmSettingsTitle: 'CRM structure',
  crmSettingsGuide: 'To connect to a CRM, please select your CRM type.',
  crmSettingDeleteWarning: 'Are you sure you want to delete structure {item}?',
  crmSettingDeleteTitle: 'Delete CRM structure',
  crmUsersTitle: 'CRM connection links',
  connectPhone: 'Phone number for connection',
  apiKey: 'API key',
  serverNo: 'Server number',
  crmUserDeleteWarning: 'Are you sure you want to delete CRM {item}?',
  crmUserDeleteTitle: 'Delete CRM',
  crmSettingsDeleteError: 'CRM deletion was not successful.',
  crmNoUrlDana: "Replace the word 'domain' with your actual domain name.",
  accessToTheMicrophoneIsNotPossible: 'Microphone access is not available',
  domain: 'Domain',
  url: 'URL',
  crmLinksGuide:
    'Guide: complete the necessary links based on CRM type for final connection.',
  managingTheAccessLevelOfCallCenterOperators:
    'Manage call center agent access levels',
  helpToActivateTheRoleOfOperatorsSelectTheirNumberAndSpecifyTheRoleAsSoonAsTheRoleIsSelectedForTheUserTheUsernameAndPasswordWillBeSentToNavatel: `Guide: to activate agent roles, select agent numbers when clicking add and assign a role. once selected, username and password are sent inside ${companyName}.`,
  reporter: 'Reporter',
  adminReporter: 'Admin reporter',
  AdminReporter: 'Admin Reporter',
  admin: 'Admin',
  support: 'Support',
  superAdmin: 'Super admin',
  SuperAdmin: 'Super Admin',
  noAccess: 'No access',
  addUser: 'Add agent',
  editUser: 'Edit agent',
  removeTheNumberTitle: 'Remove number',
  removeTheNumberText: 'The number will be removed. are you sure?',
  download: 'Download',
  subusersInsertSuccessfully: 'Agent information successfully registered',
  subusersUpdateSuccessfully: 'Agent information successfully updated',
  subusersDeleteSuccessfully: 'Agent information successfully deleted',
  selectTheDesiredNumbers: 'Select desired numbers',
  accessToAllCallCenterFacilities: 'Access to all call center features',
  accessToCallCenterMenus: 'Access to call center menus',
  accessToCallCenterSettings: 'Access to call center settings',
  fullAccessToReports: 'Full access to reports',
  fullAccess: 'Full access',
  viewReports: 'View reports',
  viewReport: 'View report',
  abilityToSendTicketsAndFollowUp: 'Ability to send tickets and follow-up',
  clickOnTheIconOppositeToView: 'Click the opposite icon to view',
  defaultItem: 'Default',
  userItem: 'Entered by customer',
  managingTheRoleOfCallCenterOperators: 'Manage call center agent roles',
  helppleaseselectyourrolenameinlatin:
    'Guide: to create a role, please enter the role name in english.',
  addRole: 'Add role',
  addANewRole: 'Add new role',
  editRole: 'Edit role',
  registerANewRole: 'Register role',
  enterTheRoleNameInEnglish: 'Enter role name in english',
  selectAll: 'Select all',
  cancel: 'Cancel',
  cancelAll: 'Cancel all',
  feature: '{count} feature',
  accesses: 'Accesses',
  roleName: 'Role name',
  roleType: 'Role type',
  deletePermissionsTitle: 'Delete role',
  deletePermissionsText: 'Role will be deleted. are you sure?',
  permissionsInsertSuccessfully: 'Role information successfully registered',
  permissionsEditSuccessfully: 'Role information successfully updated',
  permissionsDeleteSuccessfully: 'Role information successfully deleted',
  showDefaultRole: 'Show default role access level',
  showRole: 'Show role access level',
  subscriptionName: 'Subscription name',
  yourNumberOfAuthorizedNumbersIsOver:
    'Your authorized numbers limit has been reached',
  sendMessagesToOperators: 'Send messages to agents',
  sendMessagesToNavatel: 'Send messages to Navatel',
  setthelistofnumberstowhichyoucansendmessagesandsendyourmessage:
    'Guide: select agents here you can send messages to and send your message.',
  youcanselectthelistofreceivednumbersusingthebluebutton:
    'By default, the message will be sent to all numbers; use the button to select recipients.',
  text: 'Text',
  message: 'Message',
  enterthedescription: 'Enter description!',
  messageRecipients: 'Message recipients',
  sendTheMessageTitle: 'Send message',
  areyousureyouwanttosendamessagefromthechannel:
    'Are you sure you want to send a message from channel {item}?',
  sendTheMessageText:
    'Your message will be sent to all selected recipients. are you sure?',
  messageInsertSuccessfully: 'Message sent successfully',
  subject: 'Subject',
  add: 'Add',
  manageMessageRecipients: 'Manage message recipients',
  bydefaultallnumbersreceivemessages:
    'By default, all numbers receive messages',
  allNumbersReceiveMessages: 'Note: by default, all numbers receive messages',
  numberofselectedusers: 'Number of selected agents: {text}',
  numberOfSelectedUsers: 'Number of selected users',
  noMessageHasBeenEntered: 'No message has been entered',
  noNumberHasBeenSelected: 'No number has been selected',
  divertedNumber: 'Diverted number',
  addNumber: 'Add number',
  registrationOfCallForwardNumber: 'Register call forward number',
  helpEnterTheDesiredNumberAndThenSaveIt:
    'Guide: enter the number and then save it',
  enterTheNumberWith98: 'Enter the number with country code',
  enterTheMobileNumberWith98: 'Enter the mobile number with country code',
  usernameenterthemobilenumberwith98:
    '(username) enter the mobile number with country code',
  callforwardInsertSuccessfully: 'Call forward number successfully registered',
  callforwardDeleteSuccessfully: 'Call forward number successfully deleted',
  deleteCallforwardTitle: 'Delete call forward number',
  deleteCallforwardText: 'Are you sure you want to delete the number {item}?',
  theEnteredNumberIsDuplicate: 'The entered number is duplicate',
  theEnteredNumberIsNotRegistered: `The entered number is not registered in ${companyName}.`,
  theEnteredUsernameIsDuplicate: 'The entered username is duplicate',
  itispossibletoaddnumbersthatareintheblacklistfornotmakingcalls:
    'Guide: add numbers to the blacklist to block calls',
  helpenterthenumberandclicksavetoentertheblacklist:
    'Guide: enter the number and click save to add it to the blacklist',
  addNumberToBlackList: 'Add number to blacklist',
  addNumberHere: 'Add number',
  blacklistInsertSuccessfully: 'Blacklist number successfully added',
  blacklistDeleteSuccessfully: 'Blacklist number successfully deleted',
  deleteBlacklistTitle: 'Delete blacklist number',
  deleteBlacklistText: 'The blacklist number will be deleted. are you sure?',
  uploadthedesiredsoundintheuploadfieldandenteryouremailforthevoicemessage:
    'Guide: upload the desired audio to create a voicemail and enter your email for notifications',
  addVoicemail: 'Create voicemail',
  email: 'Email',
  emailto: 'Send email to ...',
  importantnoteyourfilesizeshouldnotbemorethan5mbotherwisethefilewillnotbesent:
    'Important: file size must not exceed 5mb. supported formats: MP3 or wav.',
  voicemailMessages: 'Voicemail messages',
  date: 'Date',
  duration: 'Duration',
  callTime: 'Duration',
  messages: 'Messages',
  areYouSureToDeleteTheVoiceMail:
    'Are you sure you want to delete the voicemail of number',
  voicemailInsertSuccessfully: 'Voicemail successfully registered',
  voicemailUpdateSuccessfully: 'Voicemail successfully updated',
  voicemailDeleteSuccessfully: 'Voicemail successfully deleted',
  voicemailUploadSuccessfully: 'Voicemail file successfully uploaded',
  voicemailGreetingSuccessfully: 'Voicemail greeting successfully registered',
  voicemailmessageDeleteSuccessfully: 'Voicemail message successfully deleted',
  deleteVoicemailTitle: 'Delete voicemail information',
  deleteVoicemailText: 'Are you sure you want to delete voicemail {item}?',
  deleteVoicemailMesssageTitle: 'Delete voicemail message',
  deleteVoicemailMessageText:
    'Are you sure you want to delete voicemail message {item}?',
  deleteVoicemailmessageTitle: 'Delete voicemail message',
  deleteVoicemailmessageText:
    'The voicemail message will be deleted. are you sure?',
  fileInput: 'Select file',
  selectYourFiles: 'Select your files',
  answerTicket: 'Answer ticket',
  responder: 'Responder',
  writer: 'Writer',
  addPerson: 'Add person',
  addNewPerson: 'Add new person',
  addExistingPerson: 'Add from existing persons',
  createNewPerson: 'Create Person',
  createNewCompany: 'Create Company',
  addToExistsPerson: 'Add to Existing Person',
  selectPerson: 'Select Person',
  selectCompany: 'Select Company',
  viewContact: 'View contact',
  addCompany: 'Add company',
  addNewCompany: 'Add new company',
  addToExistsCompany: 'Add from existing Companies',
  uploadInformation: 'Upload information',
  uploadInformationGuide: 'Guide: upload files to import information in bulk.',
  downloadJuridicaSampleFile: 'Download Juridica Sample File',
  downloadNaturalisSampleFile: 'Download Naturalis Sample File',
  dropFileHear: 'Drag & drop files here or',
  xlsxFormat: 'Xlsx format only.',
  gotIt: 'Got it',
  someMinutesToUpdateInformation:
    'Updating your information may take a few minutes.',
  addTimecondition: 'Add time condition',
  editTimecondition: 'Edit scheduled time condition',
  helpitispossibletocreatetimeconditionstosetreceivingcallsindifferenttimeperiods:
    'Guide: create time conditions to manage call receiving for different time ranges',
  priority: 'Priority',
  timeconditionInsertSuccessfully: 'Time condition successfully added',
  timeconditionUpdateSuccessfully: 'Time condition successfully updated',
  timeconditionDeleteSuccessfully: 'Time condition successfully deleted',
  deleteTimeconditionTitle: 'Delete time condition',
  deleteTimeconditionText:
    'Are you sure you want to delete time condition {item}?',
  noTimeCondition: 'No time conditions registered yet.',
  enterAName: 'Enter a name',
  conditions: 'Conditions',
  start: 'Start',
  end: 'End',
  theProcess: 'Action',
  accordingtotheprevioustimeconditionsenterthepriorityasanumber:
    'Enter priority as a number according to previous time conditions',
  Enter: 'Enter',
  enter: 'Enter',
  enterToNumber: 'Enter as a number',
  select: 'Select',
  searchAndSelect: 'Search And Select',
  enable: 'Enable',
  year: 'Year',
  month: 'Month',
  dayOfTheMonth: 'A day of the month',
  dayOfTheWeek: 'A day of the week',
  weekOfTheYear: 'A week of the year',
  weekOfTheMonth: 'A week of the month',
  hour: 'Hour',
  hourOfTheDay: 'An hour of the day',
  dateAndTime: 'Date & time',
  emptyNotification: 'No notifications available',
  fillingThisFieldIsMandatory: 'This field is mandatory',
  theNumberOfCharactersSelectedIsLessThanTheAllowedLimit:
    'The number of characters selected is less than the allowed limit',
  theValueEnteredIsNotValid: 'The entered value is not valid',
  textCopied: 'Text copied',
  responsiveOperator: 'Answered agent',
  allConversations: 'All conversations',
  unreadConversations: 'Unread conversations',
  readConversations: 'Read conversations',
  writeYourTextHere: 'Write your message here...',
  thereIsNoDialogueToShow: 'No dialogue available to display',
  chooseOneOfTheConversationsAndStart: 'Select a conversation and start',
  selectDepartment: 'Select department',
  selectOperator: 'Select agent',
  enterNameOrNumber: 'Enter contact name or number',
  selectDateOfLastMessage: 'Select date of last message',
  removeCdr: 'Delete call records',
  alertForRemoveCdr:
    'Are you sure you want to delete the call record with ID {item}?',
  alertForRemoveCdrs: 'Are you sure you want to delete selected call records?',
  fromTime: 'From time',
  toTime: 'To time',
  numbersOf: 'Numbers of {title}',
  divertNumbers: 'Divert numbers',
  callCenters: 'Call centers',
  ivrMenus: 'IVR menus',
  voiceMail: 'Voicemail',
  fieldRequired: 'Field is required',
  completeRequiredField: 'Please fill all required fields carefully.',
  users: 'Agents',
  addedExtention: 'Add extension',
  company: 'Company',
  noData: 'No data created yet!',
  evaluationInfo: 'Evaluator information',
  evaluationMaster: 'Evaluation expert',
  evaluationDate: 'Evaluation date:',
  evaluation: 'Evaluation',
  oprator: 'Agent',
  evaluationTime: 'Evaluation time',
  ringing: 'Ringing',
  itemsPerPage: 'Items per page',
  from: 'From',
  to: 'To',
  into: 'Into',
  realTimeMonitoringOfTheCallCenter: 'Real-time call center monitoring',
  diconectDeatail: 'Disconnect reason',
  create: 'Create',
  send: 'Send',
  sendASingle: 'Send single',
  sendASingleSms: 'Send single SMS',
  createSms: 'Create SMS',
  sendReport: 'Send report',
  reportReceive: 'Receive report',
  noConferenceReport: 'No events found',
  messageSubject: 'Message subject',
  selectTheSourceNumber: 'Select origin number',
  enterSubject: 'Enter subject',
  enterText: 'Enter text',
  selectSubject: 'Select default subject',
  saveSubject: 'Save to defaults',
  selectText: 'Select default text',
  saveText: 'Save to defaults',
  defaultSubjects: 'Default subjects',
  defaultMessages: 'Default messages',
  paste: 'Paste',
  sendSms: 'Send SMS',
  sendTiming: 'Scheduled send',
  sendConfirmation: 'Send confirmation',
  sendConfrimationText: 'Are you sure you want to send the sms?',
  noBack: 'No, back',
  yesSend: 'Yes, send',
  yesRemove: 'Yes, remove',
  yesSubmit: 'Yes, confirm',
  confirmation: 'Confirm',
  reciversCount: 'Number of recipients',
  sendingPrice: 'Sending cost',
  setSendTime: 'Set send time',
  selectSendDate: 'Select send date',
  selectReceiveDate: 'Select receive date',
  minuteHour: '(min/hour)',
  reportReceiveSend: 'Send & receive report',
  reportSend: 'Send report',
  sendStatus: 'Send status',
  filter: 'Filter',
  usersMonitoring: 'Agent monitoring',
  sendABulk: 'Send bulk',
  sendBulkGuide: 'Guide: you can send SMS to a single recipient.',
  uploadContactsFile: 'Upload contacts file',
  sendAGroupsSms: 'Send group',
  selectGroupContacts: 'Select group contacts',
  groupContacts: 'Group contacts',
  createGroup: 'Create group',
  createGroupContacts: 'Create group contacts',
  enterNameGroup: 'Enter group name',
  enterPhone: 'Enter phone number',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  selectDate: 'Select date',
  smsCount: 'Sms count',
  characterCount: 'Character count',
  contactsCount: 'Contacts count',
  contactNumber: 'Contact number',
  cancelSend: 'Cancel send',
  selectedContactCount: 'Selected contacts count',
  contact: 'Contact',
  enterContactNumber: 'Enter contact number',
  contactsGroup: 'Contacts group',
  contactsList: 'Contacts list',
  selectFromContactList: 'Select from contact list',
  addToContactsList: 'Add to contacts list',
  enterName: 'Enter name',
  enterLastname: 'Enter your last name',
  searchNameOrPhone: 'Search by name or number',
  editSingleSms: 'Edit single SMS',
  editSendTiming: 'Edit send timing',
  editConfirmation: 'Edit confirmation',
  editConfrimationText: 'Are you sure you want to edit your message?',
  editSetSendTime: 'Edit send time',
  editGroupSms: 'Edit group SMS',
  retrySend: 'Retry',
  reportStatusSend: 'Send status report',
  originNumber: 'Origin number',
  id: 'ID',
  sendGroupsSms: 'Send group SMS',
  firstCreateContactGroup: 'First create a contact group',
  groupsContacts: 'Contact groups',
  removeGroupContacts: 'Remove contact group',
  removeGroupText: 'Are you sure you want to delete the group?',
  editGroupContacts: 'Edit contact group',
  sendTime: 'Send time',
  now: 'Now',
  selectSendTime1: 'Select time',
  communicationPort: 'Source channel',
  groupEvaluation: 'Evaluation group',
  scoreCoefficient: 'Score coefficient',
  totalScore: 'Total score',
  totalScores: 'Total scores',
  minute: 'Minute',
  second: 'Second',
  submitEva: 'Submit evaluation',
  editEvaluation: 'Edit performance evaluation',
  contactName: 'Contact name',
  operatorName: 'Agent name',
  noSearch:
    'To display the report, select the date or filter and then click the search button!',
  userQaQc: 'Agent',
  smstype: 'SMS type',
  smsTypeReceive: 'Received SMS type',
  smsDetailsReceived: 'Received SMS details',
  productsList: 'Products list',
  noReport: 'Report not found!',
  nothingFound: 'Nothing found!',
  noReportProductsList1:
    'No products have been added yet. to add manually, click the button below.',
  noReportProductOptionList: 'There is no registered version for this product.',
  noProductHaveBeenRegisteredYetInDeal:
    'No product has been registered yet in deal',
  addYourProductInInvoice: 'Add your product in invoice',
  noReportProductsList2: 'Or to import a file, click the button below.',
  noReportProductsList3: 'Searched product not found!',
  downloadSample: 'Download sample',
  addNewProduct: 'Add product',
  porductName: 'Product name',
  porductCode: 'Product code',
  deleteProduct: 'Delete product',
  deleteProductText: 'Are you sure you want to delete product {item}?',
  deleteProductOption: 'Delete Option',
  areYouSureToDeleteProductOption: 'Are you sure you want to delete option?',
  areYouSureToDeleteNumberSelectedProducts:
    'Are you sure you want to delete the {number} selected products?',
  addNewCategory: 'Add category',
  categoryList: 'Product categories',
  productsNumber: 'Number of products',
  viewProducts: 'View products',
  viewmore: 'View more',
  viewless: 'View less',
  mainSpec: 'Main specification',
  productspec: 'Product specification',
  productRemoveNotAllow:
    'This product exists in the inventory. deletion is not allowed.',
  currency: 'Currency',
  porductCurrency: 'Unit currency',
  porductUnitPrice: 'Unit price',
  porductUnit: 'Unit',
  porductCategory: 'Category',
  porductCount: 'Stock',
  productOptions: 'Product versions',
  addVersionValue: 'Add version value',
  addVersion: 'Add version',
  versionAmount: 'Version name',
  versionCode: 'Version code',
  versionCost: 'Version price',
  versionCount: 'Version stock',
  versionFile: 'Upload version image',
  uploadImage: 'Upload image',
  searchKey: 'Keyword',
  addProductInInventory:
    'Stock can only be increased by recording warehouse entry.',
  register: 'Register',
  deletecategorytext: 'Are you sure you want to delete category {item}?',
  deleteCategory: 'Delete category',
  categoryEdit: 'Edit category',
  categoryName: 'Category name',
  deleteCategoryProducts: 'Delete products in this category',
  categoryProductsChange: 'Move products in this category to another category',
  productQuantityCannotBeZero: 'Product quantity cannot be zero',
  categoryTitle: 'Category title',
  enterPhoneNumberSendSingle:
    'Enter phone number (you can select up to 5 recipients)',
  callCount: 'Call count',
  waitingTime: 'Wait time',
  productWithStorage: 'Product (with inventory)',
  productWithoutStorage: 'Product (without inventory)',
  retry: 'Retry',
  manager: 'Manager',
  evaluationWithAdmin: 'Evaluation review by manager',
  evaluationWithExpret: 'Evaluation review by expert',
  managerScoreSubmited: 'Score submitted by manager',
  reportEvaluationUser: 'Users performance',
  downloadSounds: 'Download sounds',
  downloadSelectedSounds: 'Download selected sounds',
  deleteSounds: 'Delete sounds',
  deleteSelectedSounds: 'Delete selected sounds',
  createTicket: 'Create ticket',
  selectCallDate: 'Select call date',
  user: 'Agent',
  inventory: 'Inventory',
  ticket: 'Ticket',
  noTicket:
    'No ticket has been created yet. to create a ticket, click the button below.',
  clickForCreateTicket: 'Click to create ticket',
  newTicket: 'Create ticket',
  ticketTitle: 'Ticket title',
  registeredTitles: 'Registered titles',
  createInventory: 'Create inventory',
  interProductToInventory: 'Add product to inventory',
  inventoryManager: 'Inventory manager',
  province: 'Province',
  addQuantity: 'Add quantity',
  tipTypes: 'Only {types} files',
  tipMaxSize: 'up to {size} each',
  tipMaxFiles: 'with a maximum of {count} files',
  quantityInsertSuccessfully: 'Quantity added successfully.',
  searchInputInventoryPlaceholder:
    'Search inventory name, address, phone, or description',
  inventoryEmptyTitle:
    'No inventory created yet. to create one, click the button below.',
  createInventoryGuideText: 'Filling the following information is optional.',
  location: 'Address',
  updateInventory: 'Edit inventory',
  downloadSampleFile: 'Download sample file',
  interProduct: 'Add product',
  inventoryName: 'Inventory name',
  interDate: 'Entry date',
  productVersion: 'Product version',
  product: 'Product',
  quantity: 'Stock',
  addProduct: 'Add product',
  deductProduct: 'Deduct Product',
  enterQuantity: 'Enter product quantity',
  inventoryInfo: 'Inventory information',
  dateCall: 'Call date',
  qaqcEmptyGuideText:
    'To display the report, select the date or filter and click the search button!',
  qaqcEmptyListGuideText:
    'To display the call list, select the date or filter and click the search button!',
  searchAndSelected: 'Search and select',
  enterPhoneNumber: 'Enter phone number',
  addFilter: 'Add filter',
  qaqcNoResultGuideText: 'No call history found!',
  qaqcReportUserNoResultGuideText: 'Report not found!',
  searchProductNameAndProductCode: 'Search product name or code',
  inventoryHistory: 'Inventory history',
  invUser: 'Agent',
  inv: 'Inventory',
  createInv: 'Created',
  invChanged: 'Changed',
  phone: 'Phone',
  name: 'Name',
  removeInventory: 'Delete inventory',
  inventoryProductEmptyTitle:
    'No products have been added to this inventory yet.',
  productsFromThisWarehouseShouldBeRemoved:
    'Products from this inventory should be deleted.',
  theProductsFromThisWarehouseWillBeTransferredToAnotherWarehouse:
    'Products from this inventory will be transferred to another warehouse.',
  selectWarehouse: 'Select inventory',
  deletedInv: 'Deleted inventory',
  viewResultEvaluation: 'View evaluation results',
  reviewingTheEvaluationResults: 'Reviewing evaluation results',
  Unpin: 'Unpin',
  unpin: 'Unpin',
  unPin: 'Unpin',
  addTaskText: 'Click the button below to add a task.',
  viewtask: 'View task',
  untilYesterday: 'Until yesterday',
  fromTomorrow: 'From tomorrow',
  executionTime: 'Execution time',
  taskUpdateSuccessfully: 'Task updated successfully',
  taskAddedSuccessfully: 'Task added successfully',
  errorAddingTask: 'Error adding task',
  taskHistory: 'Task history',
  taskNumber: 'Task number',
  writeYourOpinion: 'Add comment',
  leads: 'Leads',
  lead: 'Lead',
  leadNotFound: 'Lead not found.',
  addLead: 'Add lead',
  addTask: 'Add task',
  createdate: 'Creation date',
  lastConnectionDate: 'Last connection date',
  lastConectionDate: 'Last connection date',
  lastConectionDatee: 'Last connection date',
  idCommunicationPort: 'Source channel ID',
  leadCreateDate: 'Lead creation date',
  searchContactPhoneOrLeadName: 'Search lead name or source channel ID',
  advancedSearch: 'Advanced filter',
  contactNameOrNumberFieldSearch: 'Contact name or number',
  men: 'Mr.',
  women: 'Ms.',
  in: 'in',
  lastFollow: 'Last follow-up date',
  resultOfTheLastConnection: 'Result of last connection',
  registrationExpert: 'Registration expert',
  submited: 'Submitted by',
  fristnameAndLastname: 'First and last name',
  addNewLead: 'Add lead',
  resultLastConection: 'Last connection result',
  thisLeadConvertedToContact: 'This lead has been converted to contact',
  dealCreatedFromThisLead: 'This deal was created from this lead',
  onlyjpegpngformatfilesupto1mbinsize: 'Only jpeg, PNG files up to 1mb.',
  info: 'Details',
  leadInfo: 'Lead information',
  leadsubtitle: 'Position in',
  leadSubtitle2: 'Business',
  leadName: 'Lead name',
  successfullyArchived: 'Successfully moved to archive',
  unarchive: 'Unarchive',
  successfullyUnarchived: 'Successfully removed from archive',
  tasks: 'Tasks',
  notFoundNoteText: 'No note created yet. click below to add a note.',
  notFoundTask: 'No task found',
  taskTitleAndType: 'Task title and type',
  creator: 'Creator',
  allTasks: 'All tasks',
  searchTasksTitle: 'Search task title',
  todayTasks: 'Due today',
  expiredTasks: 'Overdue',
  futureTasks: 'Upcoming',
  high: 'High',
  low: 'Low',
  medium: 'Medium',
  noPriority: 'No priority',
  editTask: 'Edit task',
  addConnection: 'Associate with records',
  connections: '{item} associated',
  selected: 'Selected',
  person: 'Contact',
  doer: 'Assignee',
  responsiblePerson: 'Responsible person',
  convertToContact: 'Convert to contact',
  saveToArchive: 'Move to archive',
  convertLeadType: 'Select lead conversion type:',
  addedForLinkContact: 'Add to existing contact',
  addedForNewContact: 'Add as new contact',
  fullName: 'Full name',
  selectContactType: 'Select contact type',
  contactType: 'Contact type',
  selectConvertType: 'Select conversion type',
  nextActivityDate: 'Next activity date',
  activityDate: 'Interaction date',
  searchTitleForTicketOrClient: 'Search by ticket number or client',
  ticketDeleteModalTitle: 'Delete ticket',
  ticketDeleteModalText: 'Are you sure you want to delete ticket "{item}"?',
  noTicketFound: 'No ticket found.',
  checkoutTicket: 'Check ticket',
  tickets: 'Tickets',
  ticketDeleteSuccessfully: 'Ticket deleted successfully',
  ticketInfo: 'Ticket information',
  addToContact: 'Add to contacts',
  archived: 'Archived',
  registrar: 'Submitted by',
  addNote: 'Add note',
  noteText: 'Note text',
  addNoteText: 'Click the button below to add a note.',
  notePinnedSuccessfully: 'Note pinned successfully',
  pin: 'Pin',
  unpinSuccessfully: 'Note unpinned successfully.',
  addNoteSuccess: 'Note added successfully',
  onlyJpegPngFormatFilesUpTo1mbInSize: 'Only jpeg, PNG files up to 1mb.',
  noCallHistory: 'No call history found!',
  noUser: 'No agent defined.',
  noDepartment: 'No department defined.',
  noWeb: 'No website added yet. to add a website, click the button below:',
  noLink: 'No link defined.',
  noForward: 'No number registered yet.',
  notFound: 'Nothing found.',
  noBlackListNumber: 'No number added to blacklist yet.',
  noVoiceMail:
    'No voicemail created yet. to create one, click the button below.',
  noRecording: 'No file uploaded yet.',
  sendACorresponding: 'Send corresponding',
  sendCorrespondingSms: 'Send corresponding SMS',
  selectSendTime: 'Select send time',
  selectSendDateAndTime: 'Select send date and time',
  correspondingTableText:
    'Here you can send a unique message for each number.\nprepare numbers and corresponding messages according to the sample file, then upload the file.',
  sendAParametric: 'Send parametric',
  sendParametricSms: 'Send parametric SMS',
  board: 'Board',
  reply: 'Reply',
  assignToOther: 'Assign to',
  assignToUser: 'Assign to agent',
  ticketAnswer: 'Ticket answer',
  enterTicketAnswer: 'Enter ticket answer!',
  ticketStatus: 'Ticket status',
  submitReply: 'Submit reply',
  enterNewAgent: 'Select new assignee',
  parametricTableText:
    'Here you can send a unique message for each number based on recipient-specific variables. prepare numbers and variables according to the sample file, then upload the file.',
  sample: 'Sample',
  previewNumberAndTextOfSms: 'Preview SMS number and text',
  changesHaveBeenLoaded: 'Uploaded variables',
  previewnumberandtextofsms: 'Preview number and text of sms',
  inactiveCategory: 'Selected category is inactive!',
  inactiveCategoryOfProduct: 'Selected product category is inactive!',
  productsOfThisCategoryAreExists:
    'This category has products available in stock.',
  theProductCodeIsDuplicate: 'Duplicate product code!',
  theCategoryIsDuplicate: 'Duplicate category!',
  productEditSuccess: 'Product edited successfully',
  categoryEditSuccess: 'Category edited successfully',
  fileIsNotValid: 'File is not valid!',
  assignedTo: 'Assignee',
  ticketType: 'Ticket type',
  audienceFeeling: 'Audience feeling',
  latestActivityDate: 'Latest activity date',
  choseBoardFirst: 'Select board first',
  registerDuty: 'Create task',
  leadEmptyTitle: 'No leads found, click below to create a new lead',
  leadEmptyTitleArchived: 'No archived leads found',
  archiveEmptyTitle: 'No archive found',
  hide: 'Hide',
  show: 'Show',
  salesOpportunities: 'Deals',
  createSalesOpportunities: 'Create deal',
  salesOpportunitiesTitle: 'Deal title',
  expectedClosingDate: 'Expected close date',
  amountCalculationType: 'Amount calculation type',
  addExtraProduct: 'Add extra product',
  noDataFound: 'No data found.',
  noDealFound: 'No deal found.',
  newDeal: 'Create deal',
  noDealCreatedYet: 'No deals created yet, click below to create one.',
  clickButtonBelowToCreateDeal: 'Click the button below to create a deal',
  dealDeleteModalTitle: 'Delete deal',
  dealDeleteModalText: 'Are you sure you want to delete this deal?',
  dealChangeStepText:
    'Are you sure you want to change the deal status to {item}?',
  checkoutDeal: 'View details',
  successDeal: 'Success deal',
  failedDeal: 'Failed deal',
  changeStep: 'Change status',
  totalSales: 'Total Sales',
  numberOfSuccessDeal: 'Number of success deals',
  averageSuccessRate: 'Average success rate',
  confirmDealText: 'Yes, confirm',
  dealMenu: 'Deals menu',
  createTime: 'Creation time',
  nextFollowup: 'Next activity',
  remainingTimestamp: 'Expected closing date',
  updatedAt: 'Last updated',
  desc: 'Newest',
  asc: 'Oldest',
  deals: 'Deals',
  deal: 'Deal',
  dealLine: 'Expected close date',
  nofax: 'No fax added yet, click below to add fax!',
  editDeal: 'Edit deal',
  contactGroupCreatedSuccessfully: 'Contact group created successfully!',
  contactGroupRemovedSuccessfully: 'Contact group removed successfully!',
  contactGroupUpdatedSuccessfully: 'Contact group updated successfully!',
  searchForDealUserNameOrNumber: 'Search by contact name or number',
  nextFollowupTaskDate: 'Next task date',
  basedonproduct: 'Based on product',
  converted: 'Converted',
  assign: 'Assign to',
  addDealForLead: 'Create a new deal for this account',
  added: 'Added',
  justContact: 'Added to contacts',
  contactWithDeal: 'Added to contacts and deals',
  showMore: 'Show more',
  programmersSpecial: 'Programmers special',
  newotp: 'Create OTP template',
  otpcode: 'OTP code',
  templatetitle: 'Template title',
  templatetext: 'Template text',
  entertemplatetext: 'Enter template text!',
  numberotpdigits: 'Number of OTP digits',
  validityPeriodCode: 'Code validity period',
  sendingLimitPerHour: 'Sending limit per hour',
  maximumNumberAttempts: 'Maximum verification attempts',
  WebsiteName: 'Website name',
  newOtpKeyWord:
    'Use the following parameters inside the message text using the button below.',
  enterurladdress: 'Enter URL address',
  templatecreationguide: 'Template creation guide',
  otphelperfirstp:
    'With this feature, you can send sensitive, urgent, and dynamic SMS like OTP, activation codes, security notifications, purchase invoices, or order status through service lines to your agents.',
  otphelperfirstli:
    'Sending via service lines ensures the SMS reaches agents who blocked promotional messages. these messages have high sending priority for critical interactions.',
  templatecreationsteps: 'Steps to create template',
  enteryourmessagetext: 'Enter your SMS message text.',
  otpsendtosupport:
    'Your template will be sent to support for review and approval.',
  otpuseinapitext: 'You can use this template for system SMS or via API.',
  rulesandrequirementsinsms: 'Rules and requirements for service SMS',
  otphelperfirstlitext:
    'Message text must be informational only, no advertising content.',
  otphelpersecondlitext:
    "Using promotional phrases like 'discount', 'gift', 'prize', 'special sale' will cause rejection or service line blocking.",
  otphelperthirdlitext:
    'Template must have a systematic and functional structure.',
  otphelperfourthlitext:
    'All variables in the text must be populated when sending.',
  otphelperfifthlitext:
    'Separate templates should be defined for each type of message (login, password reset, order confirmation, etc.).',
  getapikey: 'Get API key',
  copyapikey: 'Copy API key',
  sendtest: 'Send test',
  enteryournumberforsendtestsms: 'Enter the number to send a test SMS',
  sendernumber: 'Sender number',
  forcreattemplateclick: 'Click below to create a template.',
  templateCreatedSuccessfully: 'Template created successfully.',
  templateEditedSuccessfully: 'Template edited successfully.',
  testSmsSentSuccessfully: 'Test SMS sent successfully.',
  searchTitleTextOrWebsiteName: 'Search by title, text, or website name',
  otpCodeHasNotBeenInsertedYet: 'OTP code has not been inserted yet.',
  senderNumberWasSuccessfullyChanged: 'Sender number changed successfully.',
  deleteTemplate: 'Delete template',
  areYouSureDeleteTemplate: 'Are you sure you want to delete the template?',
  templateWasSuccessfullyDeleted: 'Template deleted successfully.',
  enterLeadNameNumberOrSourceChannelId:
    'Enter lead name, number, or source channel ID',
  lastDoneDutyDate: 'Last completed duty date',
  nextDutyDate: 'Next duty date',
  latestCommunicationDate: 'Latest communication date',
  resultOfLastContact: 'Result of last contact',
  filters: 'Filters',
  enterTicketNumberOrTitleOrDescription:
    'Enter ticket number, title, or description',
  creatorAgent: 'Creator agent',
  submiterAgent: 'Submitting agent',
  latestUpdateDate: 'Latest update date',
  userFeeling: 'User feeling',
  tryAggain: 'Try again',
  ticketDeleteAllSelectedTicketsModalText:
    'Are you sure you want to delete all selected tickets?',
  itemsSelected: 'Items selected',
  supportNavatel: 'Navatel support',
  whatsappNoNumber: 'No WhatsApp number available for this contact.',
  whatsappNoConnection:
    'Please enter your WhatsApp number in user settings first.',
  conversationWithConttactNotStartedOnWhatsApp:
    'No conversation started with this contact on WhatsApp yet.',
  conversationWithContactNotStartedOnNavatel:
    'No conversation started with this contact on Navatel yet.',
  returnChatPage: 'Return to chat page',
  files: 'Files',
  nameContact: 'Contact name',
  onlineChatNoNumber:
    'Please enter the contact Navatel number in the main information first.',
  changeStatusToDone: 'Mark as done',
  changeStatusToNotDone: 'Mark as not done',
  noConnections: 'No connections',
  toDo: 'To do',
  phoneCall: 'Phone call',
  sendEmail: 'Send email',
  errorAddComment: 'Error adding comment',
  showLess: 'Show less',
  enterprice: 'Enter price',
  delete: 'Delete',
  viewEvaluation: 'View evaluation',
  qaqcWarningHintForSelectingDepartment:
    'Please select a department to view evaluation criteria.',
  chosingDepartment: 'Select Department',
  criteria: 'Criteria',
  scoreMultiplyer: 'Score multiplier',
  scoresSum: 'Total scores',
  scoreSum: 'Total score',
  scoreAverage: 'Average score',
  choseScore: 'Select score',
  evaluatorExpert: 'Evaluation expert',
  evaluatorTime: 'Evaluation duration',
  submitEvaluation: 'Submit evaluation',
  managment: 'Management',
  noEvaluationYet: 'Not evaluated yet',
  leavingComment: 'Add comment',
  managmentComment: 'Management comment',
  managmentScore: 'Evaluation quality',
  commentDate: 'Comment date',
  enterDescriptions: 'Enter description!',
  noCommentSubmitted: 'No comment submitted',
  newAction: 'New action',
  addPeopleAndCompany: 'Add to existing person/company',
  setRecurringTask: 'Set recurring task',
  recurrenceType: 'Recurrence type',
  recurrenceCount: 'Recurrence count',
  recurrenceEndDate: 'End date',
  nonWorkingDaysAreNotIncluded: 'Exclude non-working days',
  times: 'times',
  dealTitleSearch: 'Deal title, buyer name',
  noPrice: 'No amount',
  notSet: 'Not set',
  assignedDate: 'Assigned date',
  assignToExpert: 'Assign to expert',
  assignToOperator: 'Assign to operator',
  createTask: 'Create task',
  searchLeadNameAndCommuunicationId:
    'Search name,lastname and communication ID',
  assignDate: 'Assign Date',
  assign_date: 'Assign Date',
  firstDoneTaskDate: 'First completed task date',
  lastDoneTaskDate: 'Last completed task date',
  allocationDate: 'Allocation date',
  firstDoneDutyDate: 'First completed duty date',
  upcomingTaskDate: 'Upcoming task date',
  latestDoneTaskDate: 'Latest completed task date',
  expectedDateOfClosure: 'Expected close date',
  delayedDealOnClosure: 'Deals delayed in closing',
  hasProformaInvoiceOrInvoice: 'Has preinvoice/invoice',
  invoiceOrProformaInvoiceStatus: 'Preinvoice/invoice status',
  invoicePaymentDate: 'Invoice payment date',
  invoicePayment: 'Invoice payment',
  selectedCount: 'Selected count',
  managementScore: 'Evaluation quality',
  ticketCounter: 'Ticket overview',
  basedOnDate: 'By date',
  basedOnUsers: 'By users',
  basedOnTitles: 'By titles',
  basedOnFailureReasons: 'By failure reasons',
  basedOnSuccessReasons: 'By success reasons',
  basedOnDepartment: 'By department',
  basedOnLastConnectionResult: 'By last connection result',
  basedOnMediaName: 'By media name',
  basedOnSubjects: 'By subjects',
  basedOneEntrance: 'By source channel',
  basedOnSLA: 'By SLA',
  ticketReport: 'Ticket report',
  dealsReport: 'Deal report',
  leadReport: 'Lead report',
  ticketsReportBasedOnDate: 'Ticket report by date',
  ticketsReportBasedOnUsers: 'Ticket report by user',
  ticketsReportBasedOnDepartment: 'Ticket report by department',
  ticketsReportBasedOnSubjects: 'Ticket report by subject',
  ticketsReportBasedOneEntrance: 'Ticket report by source channel',
  ticketsReportBasedOnSLA: 'Ticket report by SLA',
  created: 'Created',
  closed: 'Closed',
  closingRate: 'Closing rate',
  averageFirstResponseTime: 'Average first response time',
  averageClosingTime: 'Average closing time',
  enterEntrance: 'Source channel',
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  reports: 'Reports',
  report: 'Report',
  ticketsReport: 'Tickets report',
  assigned: 'Assigned',
  statusChangeWasSuccessful: 'Status change successful.',
  addToSubjects: 'Add to subjects',
  deleteTask: 'Delete task',
  deleteTaskText: 'Are you sure you want to delete this task?',
  deleteTaskSuccess: 'Task deleted successfully.',
  deleteProfile: 'Delete profile',
  deletePeopleProfile: 'Delete person profile',
  deletePeopleProfileText:
    'Are you sure you want to delete this person profile?',
  deletePeopleProfileSuccess: 'Person profile deleted successfully.',
  deleteCompanyProfile: 'Delete company profile',
  deleteCompanyProfileText:
    'Are you sure you want to delete this company profile?',
  deleteCompanyProfileSuccess: 'Company profile deleted successfully.',
  chatanswerd: 'This conversation has been answered by another agent.',
  deletedUser: 'Deleted user',
  nameOrCallNumber: 'Name or call number',
  sendOneTimePassword: 'Send one-time password',
  sendPersonalizedText: 'Send personalized text',
  selectYourTypeOfTemplate: 'Select your template type',
  customerName: 'Customer name',
  templateId: 'Template ID',
  templateType: 'Template type',
  otp: 'OTP',
  personalizedtemplate: 'Personalized template',
  settings: 'Settings',
  departement: 'Department',
  userSettings: 'Agent settings',
  noDepartmentExitsClickButtonBelowToCreateOne:
    'No department created yet. click below to create one.',
  noDepartmentFound: 'No department found',
  departmentName: 'Department name',
  departmentManager: 'Department manager',
  departmentKey: 'Department key',
  uniqueKeyHintForDepartment:
    'The key must be unique for each department. enter without spaces using english letters.',
  selectingUsers: 'Selecting users',
  hasBeenSelected: 'Selected',
  searchNameUsernameUsernumber: 'Search by name, username, agent number',
  role: 'Role',
  agreeToDeleteDepartment: 'Are you sure you want to delete department {item}?',
  deletingDepartment: 'Deleting department',
  addingMember: 'Add member',
  deletingMember: 'Remove member',
  agreeToDeleteMember: 'Are you sure you want to remove member {item}?',
  searchDepartmentNameDescription: 'Search by department name or description',
  member: 'Member',
  checkoutMembersDetail: 'View member details',
  createLead: 'Create lead',
  addToPeopleAndCompany: 'Add to existing person/company',
  createNewPeopleAndCompany: 'Create new person/company',
  descriptionLead: 'Lead description',
  descriptionCall: 'Call description',
  createFollowUpTask: 'Create follow-up task',
  leadCreatedSuccessfully: 'Lead created successfully',
  leadView: 'View lead',
  dealView: 'View deal',
  newContactAdded: 'New person/company created',
  actionSuccess: 'Action successful',
  actionFailed: 'Action failed',
  viewProfile: 'View profile',
  phoneCallOther: 'Other phone number',
  submit: 'Submit',
  callSounds: 'Call recordings',
  downloadAudioConversations: 'Download call recordings',
  downloadAllAudioSConversations: 'Download all call recordings',
  yesDownload: 'Yes, download',
  deleteConversations: 'Delete call recordings',
  deleteAllConversationsAudio: 'Delete all call recordings',
  areyousureyouwanttoactionallentitynamefromtodate:
    'Are you sure you want to {action} all {entityName} from {from} to {to}?',
  memberDeletedSuccessfully: 'Member removed successfully.',
  insufficientFunds: 'Insufficient funds',
  departmentMemberAddedSuccessfully: 'Department members added successfully.',
  departmentAddedSuccessfully: 'Department added successfully.',
  departmentUpdatedSuccessfully: 'Department updated successfully.',
  departmentDeletedSuccessfully: 'Department deleted successfully.',
  creatingNewContact: 'Creating new contact',
  downloading: 'Downloading',
  uploading: 'Uploading',
  downloaded: 'Downloaded',
  downloadsWereSuccessful: 'Downloads completed successfully.',
  saveInArchive: 'Save to archive',
  disconnectedByOperator: 'Disconnected by agent',
  busy: 'Busy',
  reject: 'Rejected',
  noAnswer: 'No answer',
  callFile: 'Call file',
  noPoll: 'No survey',
  notFoundCall: 'Call not found.',
  qas: 'Quality assessment',
  companyAgent: 'Company representative',
  submitCallDescription: 'Submit call description',
  submitTicket: 'Submit ticket',
  proFormaInvoice: 'Invoice/Preinvoice',
  toCallClickButton: 'Click the call button to make a call.',
  profile: 'Profile',
  followingContactsRegisteredWithContactNumber:
    'The following contacts are registered with this phone number',
  followingCompaniesRegisteredWithContactNumber:
    'The following companies are registered with this phone number',
  seeAll: 'See all',
  userNotFound: 'User not found',
  yourUserInfoIsNotComplete: 'Your user information is incomplete',
  addNewNumber: 'Add new number',
  other: 'Other',
  otherNumberAddedSuccessfully: 'Other number added successfully',
  otherNumberUpdateSuccessfully: 'Other number updated successfully',
  otherNumberDeletedSuccessfully: 'Other number deleted successfully',
  callList: 'Call list',
  duplicateIvr: 'The extension already exists in the queue',
  evaScore: 'Evaluation score',
  overview: 'Overview',
  noDealCreatedForThisProfile: 'No deal created for this profile!',
  nextFollowupTask: 'Next task',
  latestTicket: 'Latest ticket',
  noTicketSubmittedForThisProfile: 'No ticket submitted for this profile!',
  noTaskSubmittedForThisProfile: 'No task submitted for this profile!',
  noCallSubmittedForThisProfile: 'No call submitted for this profile!',
  latestDeal: 'Latest deal',
  latestCall: 'Latest call',
  divert: 'Divert',
  internal: 'Internal',
  unknown: 'Unknown',
  noDescriptionSubmitted: 'No description submitted',
  thereIsNoFile: 'No file available',
  nameCompanyRepresentative: 'Company representative first name',
  lastNameCompanyRepresentative: 'Company representative last name',
  description: 'Description',
  manageRoleAndPermission: 'Manage roles and permissions',
  editRoleAndPermission: 'Edit roles and permissions',
  noRoleFound: 'No role found',
  createNewRole: 'Create new role',
  enterRoleNameAndDescription: 'Enter role name and description',
  enterRoleNameInEnglish: 'Enter role name in English',
  copyFromOtherRoleAndCustomizeIt: 'Copy from another role and customize it',
  determineAccessLevelsAndPermissions:
    'Determine access levels and permissions',
  selectWayToDetermineAccess: 'Select method to determine access',
  selectDefaultRole: 'Select default role',
  reset: 'Reset',
  selectAccessLevelsAndPermissions: 'Select access levels and permissions',
  saveNewRole: 'Save new role',
  searchingFeature: 'Search feature',
  deleteAll: 'Clear all',
  selectAccessLevel: 'Select access level',
  nonSelectable: 'Non-selectable',
  roleAddedSuccessfully: 'Role added successfully.',
  roleUpdatedSuccessfully: 'Role updated successfully.',
  fileTypeText: 'Select file type for upload:',
  manageRolesAndPermissions: 'Roles & Permissions',
  accessLevelAndRights: 'Access levels and rights',
  noDealSubmittedForThisProfile: 'No deal submitted for this profile!',
  noLeadSubmittedForThisProfile: 'No lead submitted for this profile!',
  noContactSubmittedForThisProfile: 'No contact submitted for this profile!',
  noAttachmentsSubmittedForThisProfile:
    'No attachments submitted for this profile!',
  noIdentityDocumentsSubmittedForThisProfile:
    'No identity documents submitted for this profile!',
  searchNameOrLastnameOrNumberOrBusiness:
    'Search by first and last name, phone number or business',
  searchNameOrLastnameOrNumber: 'Search by first and last name or phone number',
  searchCompanyNameOrNumber: 'Search company name or phone number',
  fileIsLoading: 'File is loading',
  filecouldnotbeuploaded: 'File could not be uploaded',
  youDontHavePermissionToDoThisAction:
    "You don't have permission to perform this action on this record. If you need access, please contact the system administrator.",
  youDontHavePermissionToDoSomeOfThisAction:
    "You don't have permission to perform this action on {number} records. If you need access, please contact the system administrator.",
  unauthorized: 'Unauthorized access',
  companyAdvanceFilterPlaceholder:
    'Enter company name, agent first/last name, ...',
  peopleAdvanceFilterPlaceholder:
    'Enter first name, last name, phone number or address',
  filecouldnotbeuploadedtooltip:
    'Enter company name, agent first/last name, phone number, economic code, national id, unique code, address, note keyword',
  notAccessToFile: 'Access denied to file',
  voiceMailMessages: 'Voicemail messages',
  deletingRole: 'Deleting role',
  editDepartment: 'Edit department',
  createDepartment: 'Create department',
  firstname: 'First name',
  firstName: 'First name',
  submitterOperator: 'Follow-up agent',
  assignToGroup: 'Assign to group',
  successAssignToGroup: 'Group assignment successful',
  selectedNumber: 'Selected number',
  peopleProfileHistory: 'People profile history',
  companiesProfileHistory: 'Companies profile history',
  nextTask: 'Next task',
  otherNumbers: 'Other numbers',
  new: 'New',
  noHistoryFound: 'No history found',
  atleastOnePermissionIsRequired:
    'At least one permission is required to save the role.',
  warning: 'Warning',
  viewAndEdit: 'View and edit',
  noInvoiceSubmittedYet: 'No invoice or preinvoice has been submitted yet.',
  noProductAddedYet: 'No product has been added yet.',
  createInventoryByClickingTheButtonBelow:
    'Click the button below to create an inventory.',
  sendNow: 'Send now',
  did: 'DID',
  callCost: 'Call cost',
  fullCdrAdvancedFilterText: 'Enter contact name or number, description',
  enterHighestCallCost: 'Enter highest call cost',
  enterLowestCallCost: 'Enter lowest call cost',
  enterMinimumConversationDuration: 'Enter minimum conversation duration',
  enterMaximumConversationDuration: 'Enter maximum conversation duration',
  checkShortestWaitingTime: 'Enter shortest waiting time',
  checkLongestWaitingTime: 'Enter longest waiting time',
  noInvoiceOrPreInvoiceYet: 'No invoice or preinvoice yet.',
  creatLead: 'Create lead',
  prefix: 'Prefix',
  addUserPrefixPlaceholderText:
    'Enter at least 4 characters (numbers or letters), without country or area codes',
  closingDate: 'Closing date',
  selectCustomDate: 'Select custom date',
  noTaskCreatedYet: 'No task created yet.',
  navanumber: 'Navatel',
  navauser: 'Navatel user',
  ipphone: 'IP phone',
  departments: 'Departments',
  index: 'Row',
  members: 'Members',
  createdAtDate: 'Creation date',
  updatedAtDate: 'Updated date',
  actions: 'Actions',
  position: 'Position',
  joinedAtDate: 'Join date',
  dealTitle: 'Deal title',
  noNotesYet: 'No Notes yet.',
  updateNoteSuccessfully: 'Note updated successfully.',
  descriptionText: 'Description text',
  submitDescription: 'Submit description',
  descriptionEdit: 'Edit description',
  descriptionDelete: 'Delete description',
  descriptionDeleteText: 'Are you sure you want to delete this description?',
  contactDetailsSuccessfullyRegistered:
    'Call description successfully registered',
  contactDetailsSuccessfullyDeleted: 'Call description successfully deleted',
  contactDetailsSuccessfullyEdited: 'Call description successfully edited',
  otpMissmatch: 'OTP code does not match',
  actionDoneSuccessfully: 'Action completed successfully.',
  deleteNote: 'Delete note',
  deleteNoteText: 'Are you sure you want to delete this note?',
  errorInCallDescription: 'Error in call description submission or edit!',
  recovery: 'Recovery',
  doYouIgnoreUnsavedChanges: 'Do you want to ignore unsaved changes?',
  youHaveUnsavedChangesInThisPageIfYouContinueWithoutSaving:
    'You have unsaved changes on this page. If you continue without saving, they will be lost.',
  noCancel: 'No, cancel',
  yesExit: 'Yes, exit',
  enterCallNumber: 'Enter call number',
  exitFromArchive: 'Exit from archive',
  editPreInvoice: 'Edit preinvoice',
  createPreInvoice: 'Create preinvoice',
  createInvoice: 'Create invoice',
  evokeInvoice: 'Invoice Retrieval',
  campgainInfo: 'Campaign information',
  utmsource: 'Traffic source',
  utmcampaign: 'Campaign name',
  utmcontent: 'Ad content',
  utmmedium: 'Media type',
  ip: 'IP address',
  incomingpage: 'Landing page',
  majorType: 'Activity type',
  majorSubDomain: 'Activity sub-domain',
  table: 'Table',
  chart: 'Chart',
  smsSRSearchInputText: 'Search subject, text, submission ID',
  sendType: 'Send type',
  sent: 'Sent',
  readyToSend: 'Ready to send',
  canceled: 'Canceled',
  sending: 'Sending',
  otpSend: 'OTP send',
  groupSend: 'Group send',
  submissionId: 'Submission ID',
  delivered: 'Delivered',
  notDelivered: 'Not delivered',
  webServiceError: 'Web service error',
  wasNotFound: 'Not found',
  rejected: 'Rejected',
  failedSend: 'Send failed',
  contactsNumber: 'Contacts number',
  submissionsTotalNumber: 'Total submissions',
  shipmentsTotalCost: 'Total shipping cost',
  totalReturnCost: 'Total return cost',
  inSendQueue: 'In send queue',
  submissionSuccessRate: 'Submission success rate',
  distributingStatusMessages: 'Distributing status messages',
  toman: 'Toman',
  searchIn: 'Search in',
  searchInCampaignData: 'Search campaign data',
  searchInCampaignDataPlaceholder:
    'Traffic source, campaign name, ad content, media type, landing page',
  addMajorType: 'Add activity type',
  buyerName: 'Buyer name',
  sendSMS: 'Send SMS',
  sendByWhatsapp: 'Send via WhatsApp',
  selectCustomer: 'Select customer',
  copyDownloadLink: 'Copy download link',
  saveAndBillingPreInvoice: 'Save and send preinvoice',
  noZeroQuantityAccepted: 'Quantity cannot be zero.',
  error: 'Error',
  selectADeviceFirst: 'Select a device first',
  selectOneOrAddOne: 'Select or add one',
  addToDealTitles: 'Add to deal titles',
  ticketArchivedFilteredEmptyState: 'No archived tickets found',
  ticketArchivedEmptyState: 'No archived tickets',
  serial: 'Serial',
  phonebook: 'Phonebook',
  contacts: 'Contacts',
  groups: 'Groups',
  group: 'Group',
  submitAndAddNext: 'Submit and add next',
  lastName: 'Last name',
  male: 'Male',
  female: 'Female',
  dateOfRegistration: 'Registration date',
  deleteContacts: 'Delete contacts',
  successDeleteContact: 'Contact deleted successfully.',
  successDeleteContacts: 'Contacts deleted successfully.',
  addGroup: 'Add group',
  editGroup: 'Edit group',
  groupName: 'Group name',
  editContact: 'Edit contact',
  searchGroupName: 'Search group name',
  selectContacts: 'Select contacts',
  editGroupName: 'Edit group name',
  editMembers: 'Edit members',
  addMember: 'Add member',
  selectContact: 'Select contact',
  addToGroup: 'Add to group',
  allContacts: 'All contacts',
  notAddContactBlankPage:
    'No contacts added yet. Please add a contact using one of the methods below.',
  searchNameAndPhonesSmsContacts: 'Search by contact name, last name, number',
  disapproved: 'Disapproved',
  statusMessage: 'Status message',
  unread: 'Unread',
  hasBeenRead: 'Read',
  unreadmessages: 'Unread messages',
  totalNumberReceipts: 'Total receipts',
  unreadNumber: 'Unread count',
  smsReceiveReportSearchText: 'Search contact number',
  deleteGroup: 'Delete group',
  deleteGroups: 'Delete groups',
  successDeleteGroup: 'Group deleted successfully.',
  successDeleteGroups: 'Groups deleted successfully.',
  selectedGroupCount: 'Selected group count',
  selectedGroupContacts: 'Selected group contacts',
  createdAtOrder: 'Created date',
  updatedAtOrder: 'Last updated',
  priorityOrder: 'Priority',
  ascCreate: 'Oldest',
  descCreate: 'Newest',
  ascTask: 'Closest',
  descTask: 'Farthest',
  ascPriority: 'Lowest',
  descPriority: 'Highest',
  ascUpdate: 'Oldest',
  descUpdate: 'Newest',
  textIsSaved: 'Saved',
  ascPrice: 'Highest',
  descPrice: 'Lowest',
  orderByCreateTime: 'Creation date',
  orderByNextFollowup: 'Next activity',
  orderByPrice: 'Price',
  orderByUpdateAt: 'Last update',
  noContactHasBeenCreated: 'No contacts created yet',
  noGroupHasBeenCreated: 'No groups created yet',
  contactNotFound: 'Contact not found',
  typeAtLeastThreeChars: 'Type at least 3 characters to start searching',
  searching: 'Searching...',
  unifiedContactSearchPlaceholder:
    'Search person or company name, contact numbers, ...',
  saveAndAddNext: 'Save and add next',
  groupNotFound: 'Group not found',
  missedCalls: 'Missed calls',
  callDate: 'Call date',
  missedCallsSearchText: 'Enter contact name or number',
  makeCall: 'Make call',
  chosen: 'Chosen',
  staticMessageServiceAlert:
    'Your panel service limits are approaching the allowed threshold. For details, ',
  clicked: 'click here',
  excessiveAlert: 'Limit alert',
  disconnectionReason: 'Disconnect reason',
  chooseExpireDate: 'Choose expiration date',
  afterSendingPreInvoiceAt: 'After sending preinvoice at',
  failReason: 'Failure reason',
  buyReason: 'Purchase reason',
  addToList: 'Add to list',
  successReasonDescription: 'Purchase reason description',
  failureReasonDescription: 'Failure reason description',
  noCaseFound: 'No case found',
  providingExplanations: 'Providing explanations',
  ticketClosed: 'Ticket closed',
  hasActiveTicket: 'Has active ticket',
  taskCompleted: 'Task completed',
  taskScheduled: 'Has scheduled task',
  proformaInvoiceExpiration: ']nvoice expiration',
  invoiceCanceledRefund: 'Invoice canceled - refund',
  chatAnswered: 'This conversation has been answered',
  convertedToContact: 'Converted to contact',
  changedTheStatusOfThisConversationToEnd:
    'Changed the status of this conversation to end',
  unsuccessfulDeal: 'Unsuccessful deal',
  successfulDeal: 'Successful deal',
  activeDeal: 'Active deal',
  meetingHeld: 'Meeting held',
  missedIncomingCall: 'Incoming call - missed',
  contactCanceled: 'Contact canceled',
  callbackRequired: 'Callback required',
  loyalCustomer: 'Loyal customer',
  customer: 'Customer',
  linkedin: 'LinkedIn',
  marketingQualified: 'Marketing qualified',
  outgoingCallBusy: 'Outgoing call - busy',
  outgoingCallNoAnswer: 'Outgoing call - no answer',
  birthDate: 'Date of birth',
  followupOperator: 'Follow-up agent',
  tags: 'Tags',
  deleter: 'Deleter',
  trash: 'Trash',
  connection: 'Connection',
  registrationDate: 'Successful/unsuccessful registration date',
  invoices: 'Invoices',
  result: 'Result',
  businessActivity: 'Business activity',
  businessActivityTree: 'Business activity tree',
  transaction: 'Transaction',
  positionInBusiness: 'Position in business',
  appraiserNumber: 'Appraiser number',
  appraiserName: 'Appraiser name',
  evaluationPeriod: 'Evaluation period',
  descriptionSecondAssessment: 'Second assessment description',
  managerNumber: 'Manager number',
  managerName: 'Manager name',
  managerDescription: 'Manager description',
  operatorDescription: 'Operator description',
  firstEvaluationDescription: 'First evaluation description',
  companyId: 'Company ID',
  communicationPortalDeacon: 'Communication portal ID',
  trackingCode: 'Tracking code',
  reference: 'Reference',
  saved: 'Saved',
  allocator: 'Allocator',
  converter: 'Converter',
  conversionDate: 'Conversion date',
  transactionTitle: 'Transaction title',
  failExplanation: 'Failure explanation',
  successReason: 'Success reason',
  successExplanation: 'Success explanation',
  selectYear: 'Select year',
  contactsHistoryWasEdited: 'Edited',
  contactsHistoryWasCreated: 'Created',
  exDeleteContactProfileSectionOne: 'Are you sure you want to delete',
  exDeleteContactProfileSectionTow: 'profile?',
  exDeleteGroupContactProfileSectionOne: 'Are you sure you want to delete the',
  exDeleteGroupContactProfileSectionTow: 'selected profiles?',
  wasSuccessfullyDeleted: 'Was successfully deleted',
  profileWasSuccessfullyDeleted: 'Profile was successfully deleted',
  exDeleteNoteSectionOne: 'Are you sure you want to delete the',
  exDeleteNoteSectionTwo: '?',
  expired: 'Expired',
  done: 'Done',
  planned: 'Planned',
  oneDayBefore: 'a day before',
  anHourAgo: 'an hour ago',
  thirtyMinutesAgo: '30 minutes ago',
  and: 'and',
  notDone: 'Not done',
  exDeleteTaskSectionOne: 'Are you sure you want to delete the',
  exDeleteTaskSectionTwo: 'with code',
  exDeleteTaskSectionThree: '?',
  editTaskErrorOne:
    'Due to the due date, the scheduled status cannot be selected',
  editTaskErrorTwo:
    'The task has expired. You must select a date from the past',
  editTaskErrorThree:
    'Task completed. You must select a date from the past or today',
  requiredField: 'This field is required.',
  requiredSelect: 'Please select an item.',
  onlyEnglishIsAllowed: 'Only English letters are allowed.',
  onlyEnglishNumbersIsAllowed: 'Only English numbers are allowed.',
  noStartWithNumberIsAllowed: 'Cannot start with a number.',
  noZeroIsAllowed: 'Value cannot be zero.',
  exactLength: 'Please enter exactly {length} characters.',
  minLength: 'Please enter at least {length} characters.',
  maxLength: 'Please enter no more than {length} characters.',
  maxValue: 'Value cannot be greater than {length}.',
  confirmNotMatch: 'The entered value does not match the confirmation.',
  invalidValue: 'The entered value is invalid.',
  invalidEmail: 'The email address is invalid.',
  invalidPhone: 'The phone number is invalid.',
  nationalCodeLength: 'National code must be 10 digits.',
  nationalCodeSameDigits: 'National code cannot be 10 identical digits.',
  nationalCodeInvalid: 'National code is invalid.',
  dashNotAllowed: "Using '-' character is not allowed.",
  spaceNotAllowed: 'Using space character is not allowed.',
  charactersNotAllowed: 'Using the character(s) {chars} is not allowed.',
  noNumberInclude: 'Using numbers is not allowed.',
  bannedWordNotAllowed: 'Using "{word}" is not allowed.',
  invalidPhoneNumber: 'Invalid phone number',
  invalidInternationalMobileLengthMustBe11Digits:
    'Invalid international mobile number length (must be 11 digits)',
  invalidMobileLengthMustBe11Digits:
    'Invalid mobile number length (must be 11 digits)',
  invalidMobileWithoutZeroMustBe10Digits:
    'Invalid mobile number without leading zero (must be 10 digits)',
  invalidPhoneFormat: 'Invalid phone format',
  operatorNotFound: 'Operator not found',
  invalidLandlineLength7To13Digits:
    'Invalid landline number length (must be between 7 and 13 digits)',
  invalidInternationalLandlineLength7To13Digits:
    'Invalid international landline number length (must be between 7 and 13 digits)',
  provinceCodeNotFound: 'Province code not found',
  wrong: 'Wrong',
  irrelevant: 'Irrelevant',
  normal: 'Normal',
  unanswered: 'Unanswered',
  communicationPortFormatIsInvalid: 'The communication port format is invalid',
  idIsNotValid: 'ID is not valid',
  mustHaveAtLeastThreeCharacters: 'Must have at least three characters',
  fieldIsImpassable: 'The field is impassable',
  lastNameCannotBeLongerThanValueCharacters:
    'Last name cannot be longer than {size} characters',
  archiveCompletedSuccessfully: 'Archive completed successfully',
  kanban: 'Kanban',
  card: 'Card',
  finalNegotiation: 'Final negotiation',
  submitProposalProformaInvoice: 'Submit proposal/Proforma invoice',
  preliminaryNegotiations: 'Preliminary negotiations',
  needsAssessmentAndAnalysis: 'Needs assessment and analysis',
  dollar: 'Dollar',
  euro: 'Euro',
  pound: 'Pound',
  individual: 'Individual',
  legalEntity: 'Legal Entity',
  dealSuccessfullyCreated: 'Deal successfully created',
  dealEncounteredProblem: 'Deal encountered a problem',
  errorReceivingStatusInformation: 'Error receiving status information',
  errorReceivingBoardInformation: 'Error receiving board information',
  errorReceivingCurrencyTypeInformation:
    'Error receiving currency type information',
  salesOpportunityInformation: 'Sales opportunity information',
  default: 'Default',
  dealSuccessfullyDeleted: 'Deal successfully deleted',
  dealSuccessfullyEdited: 'Deal successfully edited',
  errorEditingDeal: 'Error editing deal',
  errorDeletingDeal: 'Error in deleting deal',
  errorInReceivingDeal: 'Error in receiving deal',
  errorInReceivingInvoiceListAndPreInvoice:
    'Error in receiving invoice and pre invoice list',
  contactDeleted: 'Contact deleted',
  lastTaskDate: 'Last task date',
  urgent: 'Urgent',
  underReview: 'Under review',
  checked: 'Checked',
  beingExamined: 'Being examined',
  ticketNumber: 'Ticket number',
  expertRemoved: 'Expert removed',
  review: 'Review',
  panel: 'Panel',
  positive: 'Positive',
  negative: 'Negative',
  neutral: 'neutral',
  deleteTaskConfirmPart1: 'Are you sure you want to delete task',
  deleteTaskConfirmPart2: 'with code',
  deleteTaskConfirmPart3: '?',
  startTime: 'Start time',
  dueDate: 'Due date',
  paid: 'Paid',
  receivingFile: 'Receiving file',
  pictures: 'Pictures',
  inventoryStock: 'Inventory stock',
  copiesNumber: 'Number of copies',
  kilogram: 'Kilogram',
  gram: 'Gram',
  liter: 'Liter',
  meter: 'Meter',
  no_unit: 'No unit',
  shut: 'Shut',
  pack: 'Pack',
  carton: 'Carton',
  box: 'Box',
  set: 'Set',
  pair: 'Pair',
  ton: 'Ton',
  millimeter: 'Millimeter',
  cubic_meter: 'Cubic meter',
  centimeter: 'Centimeter',
  square_meter: 'Square meter',
  milliliter: 'Milliliter',
  failureToCommunicate: 'Failure to communicate',
  invalidInput: 'Invalid input',
  uncertainNormal: 'Uncertain normal',
  terminationByCustomer: 'Termination by customer',
  rejectTheCall: 'Reject the call',
  diverty: 'Diverty',
  answeredByAnotherOperator: 'Answered by another operator',
  incomingCallsNumber: 'Number of incoming calls',
  incomingCallTime: 'Incoming call time',
  outgoingCallsNumber: 'Number of outgoing calls',
  outgoingCallTimes: 'Outgoing call times',
  totalNumberOfConversations: 'Total number of conversations',
  totalConversationTime: 'Total conversation time',
  incomingCallResponseRate: 'Incoming call response rate',
  notTracked: 'Not tracked',
  followingUp: 'Following up',
  followedUp: 'Followed up',
  cancelDownload: 'Cancel download',
  callsAnsweredNumber: 'Number of calls answered',
  missedCallsNumber: 'Number of missed calls',
  averageTotalCallsNumber: 'Average number of total calls',
  averageTotalCalls: 'Average total calls',
  averageIncomingCallsNumber: 'Average number of incoming calls',
  averageOutgoingCallsNumber: 'Average number of outgoing calls',
  averageOutgoingCalls: 'Average outgoing calls',
  averageIncomingCalls: 'Average incoming calls',
  AverageCallsAnsweredNumber: 'Average number of calls answered',
  queueSelection: 'Queue selection',
  deleteGroupSinglePrefix: 'Are you sure you want to delete group ',
  deleteGroupSingleSuffix: '?',
  deleteGroupMultiplePrefix: 'Are you sure you want to delete ',
  deleteGroupMultipleSuffix: ' groups?',
  deleteContactSinglePrefix: 'Are you sure you want to delete contact ',
  deleteContactSingleSuffix: '?',
  deleteContactMultiplePrefix: 'Are you sure you want to delete ',
  deleteContactMultipleSuffix: ' contacts?',
  addedSuccessfully: 'Added successfully',
  editedSuccessfully: 'Edited successfully',
  correspondingUniqueMessageText:
    'The unique message text for each number is displayed here',
  notSelectedExcelFile: 'The selected file is not an Excel file',
  selectYourDesiredDate: 'Select your desired date',
  firstNameAndLastName: 'First and Last name',
  validityDate: 'Validity date',
  renewalDate: 'Renewal date',
  validityPeriod: 'Validity period',
  creditType: 'Credit type',
  recipients: 'Recipients',
  reimbursement: 'Reimbursement',
  dateAndTimeSending: 'Date and time of sending',
  submitted: 'Submitted',
  details: 'Details',
  generalManager: 'General manager',
  accountabilityExpert: 'Accountability expert',
  operatorNumber: 'Operator number',
  allowedNumberDefinitions: 'Access to allowed number definitions',
  userSettingsManagement: 'User settings management',
  roleManagementAccess: 'Role management access',
  systemSettingsAccess: 'System settings access',
  conversationsDisplay: 'View conversations',
  persian: 'Persian',
  english: 'English',
  german: 'German',
  randomRoundRobinStrategy: 'Random strategy with round robin algorithm',
  allOperatorsMessageStrategy: 'Message receiving strategy from all operators',
  leastReceivedMessageStrategy:
    'Strategy with the lowest message recipient load',
  right: 'Right',
  left: 'Left',
  evaluatedCallCount: 'Number of evaluated calls',
  averageEvaluationScore: 'Average evaluation score',
  averageSurveyScore: 'Average survey score',
  private: 'Private ',
  public: 'Public',
  navatelUsersUsernamePassword: 'Navatel users (username, password)',
  numberLineStatus: 'Number status',
  crmType: 'CRM type',
  urlAddress: 'Url address',
  selectiveCrm: 'Selective crm',
  requestDate: 'Request date',
  answered: 'Answered',
  technical: 'Technical',
  financial: 'Financial',
  sales: 'Sales',
  you: 'You',
  lastDay: 'Last day',
  lastWeek: 'Last week',
  lastMonth: 'Last month',
  languageChange: 'Language change',
  ticketText: 'Ticket text',
  responseToTicket: 'Response to ticket',
  less: 'Less',
  more: 'More',
  refund: 'Refund',
  featureRequest: 'Feature request',
  question: 'Question ',
  problem: 'Problem',
  loading: 'Loading',
  ticketAllocation: 'Ticket allocation',
  yourCommentWasSuccessfullySubmitted:
    'Your comment was successfully submitted',
  submittedSuccessfully: 'Submitted successfully',
  transferred: 'Transferred',
  call: 'Call',
  language: 'Language',
  chooseLanguage: 'Choose language',
  itemHasAlreadyBeenAdded: 'This item has already been added',
  phoneNumberEnteredIsDuplicate: 'The phone number entered is a duplicate',
  selectAGroup: 'Select a group',
  inaccessibilityToGroupList: 'Inaccessibility to the group list',
  evaluationInformationNotFound: 'No evaluation information found',
  startCall: 'Start the call',
  identifyingCustomerNeeds: 'Identifying customer needs',
  maintainingProfessionalCourtesyAndCustomerInteraction:
    'Maintaining professional courtesy and customer interaction',
  suggestRightSolutionAndRecordProblem:
    'Suggest the right solution and record the problem',
  technicalSkills: 'Technical skills',
  endCall: 'End call',
  dealSidebarMenu: 'Deals',
  invoicePreInvoiceSidebarMenu: 'Invoices',
  costHistoryChart: 'Cost chart',
  groupSidebarMenu: 'Group',
  single: 'Single',
  bulk: 'Bulk',
  corresponding: 'Corresponding',
  parametric: 'Parametric',
  onceADay: 'Once a day',
  onceAWeek: 'Once a week',
  onceAMonth: 'Once a month',
  sendHour: 'Send time',
  CUallowedRangeBetweenOneAndThree: '(Allowed range between 1 and 3)',
  companion: 'Companion',
  withinProvince: 'Within the province',
  interProvincial: 'Interprovincial',
  abroad: 'Abroad',
  successfullyRegistered: 'Successfully registered',
  evaluationHasNotBeenRegistered: 'The evaluation was not registered',
  commentWasNotRegistered: 'Comment was not registered',
  warehouseCreatedSuccessfully: 'Warehouse created successfully',
  warehouseEditedSuccessfully: 'Warehouse successfully edited',
  productAddedSuccessfully: 'Product added successfully',
  productUpdatedSuccessfully: 'Product updated successfully',
  duplicateProduct: 'Product already exists',
  productRemovedFromInventorySuccessfully:
    'Product successfully removed from inventory',
  productDeductedFromInventorySuccessfully:
    'Product successfully deducted from inventory',
  inventoryDeletedSuccessfully: 'Inventory successfully deleted',
  selectInventoryManager: 'Select Inventory Manager',
  CUInventoryNameMaxLengthCharacters:
    'Inventory name must be less than 20 characters',
  languages: 'Languages',
  CUFrom: 'From',
  representativeContactNumber: 'Representative contact number',
  dealForThisLead: 'For this deal',
  leadToContact: 'This clue to the audience',
  '... created': 'created',
  '... updated': 'updated',
  '... pinned': 'pinned',
  '... assigned': 'assined',
  '... deleted': 'deleted',
  '... archived': 'archived',
  '... unarchived': 'unarchived',
  '... converted': 'converted',
  '... revoked': 'Revoked',
  '... convertedToInvoice': 'converted into an invoice',
  selectProduct: 'Select product',
  inventoryCannotBeZero: 'Inventory cannot be zero',
  navatelNumbers: 'Navatel numbers',
  kilometer: 'Kilometer',
  attention: 'Attention',
  theEconomicCodeMustBeNumberOrNumberDigits:
    'The economic code must be between {number1} and {number2} digits long',
  submitOffer: 'Submit offer',
  sendingPreInvoice: 'Sending Preinvoice',
  leadToSales: 'Lead to sales',
  deleteLead: 'Delete lead',
  areYouSureToDeleteLead: 'Are you sure you want to delete this clue?',
  areYouSureToDeleteNumberSelectedLeads:
    'Are you sure you want to delete the {number} selected leads?',
  CULeadConvertedOpportunityCreated:
    'Lead has been converted into a contact, creating a sales opportunity',
  standardGreeting: 'Standard greeting with appropriate tone and pace',
  addressingByName: 'Addressing the customer by name during the call',
  askingQuestions: 'Asking questions to understand the customer issue',
  correctInfoGathering:
    'Collecting accurate customer information to introduce suitable services',
  correctAnswering:
    'Providing accurate answers and clear explanations to the customer',
  politeness: 'Being polite and using respectful tone during the conversation',
  buildingTrust: 'Building trust and confidence in the company',
  empathyAndListening:
    'Showing empathy, active listening, and speaking clearly without rushing',
  timeManagement: 'Managing response time appropriately',
  accurateInfo:
    'Providing accurate and relevant information based on guidelines',
  understandingNeed:
    'Understanding customer needs and assuring issue resolution',
  providingSolutions:
    'Providing solutions and alternative options using available resources',
  problemSolving:
    'Resolving customer issues and creating tickets when necessary',
  handlingComplaint:
    'Managing conversations professionally during customer complaints',
  productKnowledge: 'Having sufficient knowledge about products and systems',
  ticketRecording: 'Recording tickets properly according to standards',
  correctReasonSelection:
    'Selecting the correct contact reason and proper referral',
  holdManagement:
    'Using hold properly with explanation and avoiding unnecessary silence',
  callSummary: 'Summarizing the call and confirming complete response coverage',
  callClosure:
    'Following proper call closure standards and encouraging feedback',
  cellNumber: 'Cell number',
  selectTimeMinutesAndHours: 'Select time (minutes/hours)',
  emailTo: 'Email to ...',
  leadHistory: 'Lead history',
  enterNewFieldTitle: 'Enter new field title',
  addNewField: 'Add new field',
  additionalInformation: 'Additional information',
  additionalInformationEdit: 'Additional information edit',
  additionalInformationFieldsEdit: 'Additional information fields edit',
  changesMadeFieldsBelowWillAppliedAllProfiles:
    'Changes made to the fields below will be applied to all your profiles.',
  deleteField: 'Delete field',
  areYouSureYouWantToDeletefild: 'Are you sure you want to delete fild {item}?',
  conversationWithContactHasNotYetStartedWhatsApp:
    'A conversation with this contact has not yet started on WhatsApp.',
  anAmount: 'an Amount',
  anPercent: 'an Percent',
  naturalPerson: 'Natural person',
  legalCompany: 'Legal company',
  selectAutoCompletePlaceholder:
    'Enter the desired title or select from registered titles',
  ticketTitlePlaceholder: 'Enter or select a title',
  addSalesOpportunityTitles: 'Add to sales opportunity titles',
  areYouSureWantToDeleteTitle: 'Sure you want to delete this title?',
  registerNewTitle: 'Add new title',
  ticketCreatedSuccessfully: 'Ticket created successfully',
  noteOnceTicketClosedWarning:
    'Note: Once a ticket is closed, it cannot be changed.',
  ticketClose: 'Ticket close',
  ticketChangeStatusWarning:
    'Are you sure you want to change the ticket status to {item}?',
  smsParametricSampleMessage:
    '<span>Dear customer </span><span class="hashtag-highlight">#FirstNameAndLastName#</span><span> your validity date is until </span><span class="hashtag-highlight">#ValidityDate#</span><span>. Please renew your subscription before May 19.</span>',
  brokenDestination: 'Broken destination',
  timeToDo: 'Time to do',
  invoiceEmptyTitle:
    'No invoice created yet. to create one, click the button below.',
  label: 'label',
  createLabel: 'Create label',
  addLabel: 'Add label',
  newLabel: 'New label',
  editLabel: 'Edit label',
  labelName: 'Label name',
  colorSelectionMandatory: 'Color selection is mandatory',
  deleteLabel: 'Delete label',
  areYouSureWantToRemoveFollowingTag:
    'Are you sure you want to remove the following tag from the tag list?',
  archivedLeadEditDisabled: 'Editing archived leads is not available.',
  archivedLeadCallDisabled: 'Adding calls is not available for archived leads.',
  archivedLeadTaskDisabled:
    'Creating tasks is not available for archived leads.',
  archivedLeadNoteDisabled: 'Adding Notes is not available for archived leads.',
  archivedLeadAssignDisabled: 'Assigning is not available for archived leads.',
  archivedLeadAddToContactDisabled:
    'Adding archived leads to contacts is not available.',
  archivedLeadSmsDisabled:
    'Sending SMS messages is not available for archived leads.',
  archivedLeadChangeStatusDisabled:
    'Changing status is not available for archived leads.',
  automation: 'Automation',
  workflow: 'Workflow',
  executionDate: 'Execution Date',
  workflowName: 'Workflow name',
  workflowType: 'Workflow type',
  workflowStatus: 'Workflow status',
  searchWorkflowName: 'Search workflow name',
  relatedModule: 'Related Module',
  triggerType: 'Trigger Type',
  action: 'Action',
  executionCount: 'Execution Count',
  autoSendSmsAfterCall: 'Automatically send SMS after call ends',
  autoSendSmsAfterContactCreation:
    'Automatically send SMS after creating a contact in CRM',
  birthdayGreetingWorkflow:
    'Send birthday greetings to contacts registered in CRM',
  eventBased: 'Event-based',
  workflowInformation: 'Workflow Information',
  executionReports: 'Execution Reports',
  disableWorkflowFirst: 'Please disable the workflow first',
  event: 'Event',
  lastExecution: 'Last Execution',
  lastEdit: 'Last Edit',
  lastExecutionDate: 'Last Execution Date',
  workflowChangeHistory: 'Workflow Change History',
  executionConditions: 'Execution conditions',
  executionType: 'Execution type',
  eventModule: 'Event Module',
  condition: 'Condition',
  workflowExecutionReport: 'Workflow Execution Report',
  workflowExecution: 'Workflow Execution',
  exit: 'Exit',
  workflowExecutions: 'Workflow Executions',
  eventDate: 'Event Date',
  executionStatus: 'Execution Status',
  rerun: 'Rerun',
  saveAsInactive: 'Save as Inactive',
  editWorkflow: 'Edit Workflow',
  selectWorkflowStartMethod: 'Select how the workflow should start.',
  selectEventModule: 'Select the event module',
  selectEvent: 'Select the event',
  eventAccording: 'Event-Based',
  timeBased: 'Time-Based',
  port: 'Port',
  selectInlineVariableField: 'Select an Inline Variable Field',
  inlineVariableFieldDescription:
    'To personalize the SMS message, you can select contact fields and insert them into the message. Alternatively, while typing, press the # key to choose and insert a variable field.',
  field: 'Field',
  addCondition: 'Add Condition',
  selectModule: 'Select the module',
  selectRepeatInterval: 'Select the repeat interval.',
  selectStartDate: 'Select the start date.',
  confirmExecution: 'Yes, Run',
  confirmWorkflowActivationMessage:
    'Are you sure you want to {action} “{title}”?',
  reviewAndActivateWorkflow: 'Review and Activate Workflow',
  confirmActivate: 'Yes, Activate',
  reviewAndDeactivateWorkflow: 'Review and Deactivate Workflow',
  confirmDeactivate: 'Yes, Deactivate',
  deactivation: 'Deactivation',
  call_center: 'Call center',
  send_sms: 'Send SMS',
  completeRequiredConfigurationToActivateWorkflow:
    'To activate this workflow, complete the required configuration.',
  noWorkflowExecutions: 'This workflow has not been executed yet.',
  archivePreinvoice: 'Archive Proforma Invoice',
  archiveInvoice: 'Archive Invoice',
  archivePreinvoiceConfirmation:
    'Are you sure you want to archive the proforma invoice {item}?',
  archiveInvoiceConfirmation:
    'Are you sure you want to archive the invoice {item}?',
  confirmArchive: 'Yes, Archive',
  unarchivePreinvoice: 'Unarchive Proforma Invoice',
  unarchiveInvoice: 'Unarchive Invoice',
  unarchivePreinvoiceConfirmation:
    'Are you sure you want to unarchive the proforma invoice {item}?',
  unarchiveInvoiceConfirmation:
    'Are you sure you want to unarchive the invoice {item}?',
  confirmUnarchive: 'Yes, Unarchive',
  preinvoiceAndInvoice: 'Preinvoice and invoice',
  dealEmptyTitleArchived: 'No archived deals found.',
  activitiesLog: 'Activity history',
  activity: 'Activity',
  activityStatus: 'Activity status',
  noStatus: 'No status',
  waitingFollowUp: 'Awaiting follow-up',
  immediateFollowUp: 'Immediate follow up',
  processed: 'Processed',
  timeLineSearchText: 'Search for a contact name or number',
  updateTaskStatus: 'Update task status',
  updateLeadStatus: 'Update lead status',
  convertLead: 'Convert lead',
  receiveSMS: 'Receive SMS',
  ticketChangeStatus: 'Ticket change status',
  convertingPreInvoice: 'Converting PreInvoice',
  paymentPreInvoice: 'Payment PreInvoice',
  changeDealStatus: 'Change deal status',
  taskDeferral: 'Deferral of task',
  taskDone: 'Task done',
  inbound: 'Receive',
  fail: 'Fail',
  expire: 'Expire',
  evoke: 'Evoke',
  convert: 'Convert',
  changeStatus: 'Change status',
  stepUpdate: 'Change status',
  unrelated: 'Unrelated',
  nostate: 'No state',
  updateStatusLead: 'Update lead status',
  viewActivities: 'View activities',
  viewCommunicationHistory: 'View communication history',
  communicationHistory: 'Communication history',
  relatedLeads: 'Related leads',
  viewMoreDetails: 'View more details',
  viewLessDetails: 'View less details',
  noRelatedLead: 'No related leads found',
  activitiesDate: 'Activities date',
  editTicket: 'Edit ticket',
  update: 'Update',
  previousStatus: 'Previous status',
  viewDealProfile: 'View deal profile',
  viewTicketProfile: 'View ticket profile',
  noActivityFound: 'No activity found',
  viewPreInvoice: 'View pre invoice',
  viewInvoice: 'View invoice',
  receivedSMS: 'Received SMS',
  sentSMS: 'Sent SMS',
  noActivityHasBeenRecordedYet: 'No activity has been recorded yet',
  incomingSuccessful: 'Incoming - Successful',
  outboundSuccessful: 'Outbound - Successful',
  incomingConnectionFailure: 'Incoming - Connection Failure',
  outboundConnectionFailure: 'Outbound - Connection Failure',
  incomingInvalidIncoming: 'Incoming - Invalid Incoming',
  outboundInvalidIncoming: 'Outbound - Invalid Incoming',
  incomingNoAnswer: 'Incoming - NoAnswer',
  outboundNoAnswer: 'Outbound - NoAnswer',
  incomingCallRejected: 'Incoming - CallRejected',
  outboundCallRejected: 'Outbound - CallRejected',
  incomingDisconnectedByCustomer: 'Incoming - Disconnected by customer',
  outboundDisconnectedByOperator: 'Outbound - Disconnected by operator',
  incomingUnknownStandard: 'Incoming - Unknown Standard',
  outboundUnknownStandard: 'Outbound - Unknown Standard',
  incomingUserBusy: 'Incoming - User busy',
  outboundUserBusy: 'Outbound - User busy',
  cardNotFound: 'Card not found',
  createPeople: 'Create people',
  createCompanies: 'Create companies',
  representative: 'Representative',
  peopleAndCompanies: 'People and companies',
  portalDeacon: 'Portal deacon',
  updateLead: 'Update lead',
  saveAsActive: 'Save as Active',
  confirmWorkflowSaveAsActiveMessage:
    'Are you sure you want to save as active the workflow {item}?',
  selectAnActivity: 'Select an activity.',
  lastUpdateDate: 'Last Update Date',
  completionDate: 'Completition Date',
  duplicatePhoneNumber: 'This phone number has already been registered.',
  duplicateProfilesFound:
    'The following profiles are registered with this phone number',
  duplicatePhoneAlert: 'This phone number has already been registered.',
  noProfileAccess: 'You do not have access to view this profile!',
  moreActions: 'More Actions',
  addTag: 'Add tag',
  upgrade: 'Update',
  upsert: 'Update And insert',
  selectImportMethod: 'Select Upload Information Method',
  uploadExampleHint:
    'Enter your information according to the sample file and then upload it:',
  rows: 'Rows',
  uploadEncounteredProblem: 'File processing completed with some errors.',
  incompleteUploadHintText:
    '{successCount} of {totalCount} rows were successfully updated. {failedCount} rows were not applied due to errors.',
  informationUpgradedSuccessfully: 'Information was successfully updated.',
  uploadWasntDone: 'Information upload was not completed.',
  formatIsNotValidText:
    'The file format or structure is not valid. Please correct the file according to the sample template and upload it again.',
  outputDownload: 'Download output',
  downloadBasedOn: 'Download based on',
  allFields: 'All fields',
  customization: 'Customization',
  notes: 'Notes',
  technicalInfo: 'Technical Information',
  ipAddress: 'IP Address',
  deviceType: 'Device Type',
  os: 'Operating System',
  browser: 'Browser',
  appVersion: 'App Version',
  customerSerial: 'Customer Serial',
  agentFullName: 'Agent Full Name',
  representativePhoneNumber: 'Representative phone number',
  representativeNationalId: 'Representative nation id',
  website: 'Website',
  contactFullName: 'Contact Name',
  secondaryPhone: 'Secondary Phone',
  callQueueName: 'Queue Name',
  surveyScore: 'Survey Score',
  uploadPngLogoHint: 'PNG format, 1:1 aspect ratio (square)',
  uploadStampAndSignaturePngHint: 'PNG format, 2:1 aspect ratio (horizontal)',
  recurrenceInterval: 'Recurrence Interval',
  bulkDeleteTasks: 'Bulk Delete Tasks',
  bulkDeleteTasksConfirm: 'Are you sure you want to delete the selected tasks?',
  taskDeletedSuccess:
    'Task deleted successfully. | Tasks deleted successfully.',
  createWorkflow: 'Create Workflow',
  callCenter: 'Call center',
  yearly: 'Yearly',
  selectField: 'Select field',
  chooseOperator: 'Select an operator',
  selectFieldValues: 'Select field values',
  equals: 'Equals',
  notEquals: 'Not equals',
  contains: 'Contains',
  notContains: 'Does not contain',
  startsWith: 'Starts with',
  endsWith: 'Ends with',
  isEmpty: 'Is empty',
  isNotEmpty: 'Is not empty',
  before: 'Before',
  after: 'After',
  between: 'Between',
  notBetween: 'Not between',
  greaterThan: 'Greater than',
  greaterThanOrEqual: 'Greater than or equal',
  lessThan: 'Less than',
  lessThanOrEqual: 'Less than or equal',
  deleteWorkflow: 'Delete workflow',
  confirmDeleteWorkflowWithWorkflow:
    'Are you sure you want to delete the {item} workflow?',
  workflowDeletedSuccessfully: 'Workflow deleted successfully.',
  workflowCreatedSuccessfully: 'Workflow created successfully.',
  workflowEditedSuccessfully: 'Workflow edited successfully.',
  ticketTag: 'Ticket Tag',
  ticketView: 'Ticket View',
  ticketHistory: 'Ticket history',
  '... repliedTo': 'Replied',
  callRecording: 'Call recording',
  abilityToRecordOutgoingCalls: 'Ability to record outgoing calls',
  abilityRecordInternalInternalCalls:
    'Ability to record internal-to-internal calls',
  callRatings: 'Call ratings',
  outboundCallSurveyCapability: 'Outbound call survey capability',
  yes: 'Yes',
  order_by_create_time: 'Creation Date',
  order_by_next_followup: 'Next activity',
  order_by_price: 'Price',
  order_by_update_at: 'Update Date',
  next_follow_up_date: 'Next activity',
  created_at_order: 'Creation Date',
  updated_at_order: 'Update Date',
  priority_order: 'Priority',
  newest: 'Newest',
  oldest: 'Oldest',
  highestPriority: 'Highest Priority',
  lowestPriority: 'Lowest Priority',
  mostExpensive: 'Most Expensive',
  cheapest: 'Cheapest',
  assignToExpertLabel: 'Assign To Expert',
  selectTheDate: 'Select date',
  selectFieldValue: 'Select field value',
  enterFieldValue: 'Enter field value',
  module: 'Module',
  withoutCondition: 'Without condition',
  boards: 'Boards',
  numberOfRules: 'Number of rules',
  numberOfStatus: 'Number of status',
  boardRules: 'Board rules',
  boardName: 'Board name',
  createBoard: 'Create board',
  copyBoard: 'Copy board',
  deleteBoardItem: 'Delete {item} board',
  deleteBoard: 'Delete board',
  deleteBoardConfirm: 'Are you sure you want to delete the board {item}?',
  deleteBoardWarning: 'This action cannot be undone.',
  boardDeletedSuccessfully: 'Board deleted successfully.',
  copyFromBoard: 'Copy from board',
  boardWantToCopyFrom: 'The board you want to copy from',
  backToBoardsList: 'Back to boards list',
  Configuration: 'Configuration',
  rules: 'Rules',
  sorting: 'Sorting',
  stateName: 'State name',
  color: 'Color',
  closedOrOpen: 'Closed or open',
  ticketCount: 'Ticket count',
  statuses: 'Statuses',
  selectTheColor: 'Select the color:',
  editedItemsCount: 'Number of edited items',
  confirmDeleteBoard: 'Are you sure you want to delete the board "{item}"?',
  boardCannotBeDeletedWarning:
    'This board cannot be deleted because it currently contains records and/or is in use. Please check the configuration table to review and remove any related usage.',
  defaultStatus: 'Default status',
  selectDefaultStatusWhichRecordsCreated:
    'Select the default status in which new records are created.',
  usersCanOnlyCreateWarning:
    'Users can only create new tickets in selected statuses.',
  ticketsCannotSelectSelectedStatuses:
    'Tickets cannot select the selected statuses.',
  otherStatuses: 'Other statuses',
  selectStatuses: 'Select statuses',
  ticketsCannotMoveBackward:
    'tickets cannot move backward from the selected statuses',
  limitRolesCanEditTicketsInSelectedStatus:
    'Limit the roles that can edit tickets in the selected status',
  selectWhichRolesCanEditTicketsInEachStatus:
    'Select which roles can edit tickets in each status.',
  ticktSettingsRulesTableWarningText:
    'Note: These rules do not apply to the creation or editing of tickets on boards, nor to senior managers or users with permission to edit the feature.',
  ticketSettings: 'Ticket settings',
  returnToTickets: 'Return to tickets',
  addStatus: 'Add status',
  ticketsRequireApprovalReachFollowingStatuses:
    'Tickets will require approval once they reach the following statuses.',
  selectEditAccessForSelectedBoard:
    'Select the edit access for the selected board:',
  workflowEdited: 'Workflow edited',
  workflowAction: '{0} the workflow.',
  editBoardName: 'Edit board name',
  backToTickets: 'Back to tickets',
  editBoard: 'Edit board',
  viewSettings: 'View settings',
  productImage: 'Product image',
  versionName: 'Version name',
  mainVersion: 'Main version',
  versionImage: 'Version image',
  numberValue: 'Number',
  noteInserSuccessfully: 'Note added successfully.',
  addExistingCompany: 'Add from existing companies',
  Notetext: 'Note text',
  overdue: 'Overdue',
  tasksReport: 'Tasks report',
  allDepartements: 'All departments',
  allStatuses: 'All statuses',
  allResults: 'All results',
  allMediaNames: 'All media names',
  itIsNecessaryToSelectAtLeastOneProduct:
    'Selecting at least one product is required.',
  '... assignedAnotherOperator': 'assigned it to another operator',
  timeAccording: 'According to time',
  configuration: 'Configuration',
  lastInteraction: 'Last interaction',
  lastInteractionDate: 'Last interaction date',
  saveChangesQuestion: 'Should the changes be saved?',
  companySize: 'Company size',
  enterEmployeesCount: 'Enter number of employees',
  smsRecipient: 'SMS Recipient',
  contactFollower: 'Contact Follow-up Specialist',
  customUsers: 'Custom Users',
  selectCustomUser: 'Select Custom Users',
  selectCustomUsersFirst: 'Select the users option first',
  noFileToShow: 'No File To Show',
  conversationWithContactHasNotYetStarted:
    'conversation with this contact has not yet started yet in {chatType}',
  copied: 'Copied',
  boardRuleError: 'Board Rule Error',
  noBackwardRuleError:
    'According to the policy of this board, you cannot revert tickets from this status to earlier statuses',
  noAccessToChangeClosedTicket:
    'You do not have access to change the status of this ticket from or to the “closed” status.',
  noSkipRuleError:
    "According to this board's rules, you do not have the ability to skip tickets from certain statuses.",
  targetStatus: 'Target Status',
  changeFromThisStatusToThatConfirmation1:
    'Are you sure of change ticket status from',
  changeFromThisStatusToThatConfirmation2: '',
  ticketOpen: 'Opening Ticket',
  permissionError: 'Permission Error',
  changeStatusAccessError: 'you dont have access to change status',
  registerApi: 'Register API',
  registerPattern: 'Register Pattern',
  registeredNumbers: 'Registered Numbers',
  api_key: 'API Key',
  messenger: 'Messenger',
  testConnection: 'Test Connection',
  melipayamak: 'Meli Payamak',
  sms_ir: 'sms.ir',
  confirmDeleteSmsApi: 'Are you sure to delete {item} API',
  successfulConnection: 'Successful Connection',
  failedConnection: 'Failed Connection',
  upadatedSuccessfully: 'Upadated Successfully',

  personName: 'Person name',
  stockIn: 'Stock In',
  stockOut: 'Stock Out',
  stockManagement: 'Stock Management',

  contactTickets: 'Contact Tickets',
  deletedDepartment: 'Deleted department',
  personNatural: 'Person (Natural)',
  companyLegal: 'Company (Legal)',
  country: 'Country',
  street: 'Street',
  licensePlateNumber: 'License plate number',
  birthCertificateNumber: 'Birth Certificate Number',
  nationality: 'Nationality',
  editField: 'Edit Field',
  singleSelectField: 'Single Select Option',
  multiSelectField: 'Multi Select Option',
  shortTextField: 'Short text field (maximum 255 characters)',
  enterOptionsValue: 'Enter the option values: (Enter at least one option)',
  timeDuration: 'Time Duration',
  notificationReceivers: 'Notification Recipients',
  timeCondition: 'Time Condition',
  leadDestinationdeal: 'Move to Deal',
  leadDestinationlead: 'Keep in Lead',
  leadDestinationcontact: 'Move to Contact',
  oneWeek: 'One Week',
  twoWeek: 'Two Weeks',
  oneMonth: 'One Month',
  twoMonth: 'Two Months',
  threeMonth: 'Three Months',
  afterLastArchive: 'After the Last Edit',
  editedCount: 'Number of Edited Items',
  createEntityType: 'Create {entityType}',
  generalSettings: 'General Settings',
  fieldsManagement: 'Field Management',
  company_assign_creator_as_followup:
    'When creating a company, automatically assign the creator as the follow-up specialist.',
  company_unique_phone:
    'When creating a company, each phone number can only be registered once.',
  people_assign_creator_as_followup:
    'When creating a person, automatically assign the creator as the default follow-up specialist.',
  people_unique_phone:
    'When creating a person, each phone number can only be registered once.',
  colorPalette: 'Color Palette',
  createdLabels: 'Created Labels',
  required: 'Required',
  duplicateWarning: 'Duplicate Entry Warning',
  fieldType: 'Field Type',
  changesMadeSuccessfully: 'Changes Applied Successfully',
  setting: 'Settings',
  leadUniquePhone:
    'When creating a lead, allow multiple leads to be registered with the same phone number.',
  leadAssignCreatorAsFollowup:
    'When creating a lead, automatically assign the creator as the follow-up specialist.',
  notificationBasedOnFirstAction:
    'Send notification based on the first action on the lead',
  notificationAfterNoAction:
    'If no action is taken on the lead for the specified period after creation, automatically send a notification to the recipients below.',
  notificationBasedOnLastContactResult:
    'Send notification based on the result of the last contact',
  notificationAfterLastContactResult:
    'If the result of the last contact was one of the options below and no action was taken for the specified period, automatically send a notification to the recipients below.',
  autoArchiveUneditedLeads:
    'Leads that have remained unedited for the specified period will be automatically archived.',
  leadConversionConditions: 'Lead Conversion Conditions',
  leadNotes: 'Lead Notes',
  leadTable: 'Lead Table',
  leadTasks: 'Lead Tasks',
  fieldTitle: 'Field Title',
  lastNote: 'Last note',
  cantCreateNewContactWithThisNumber:
    'The profiles below were created with this contact number. According to your settings, you cannot create a new contact.',
  sameNumber: 'Same number',
  enterAtleastOneOption: 'Enter at least one option',
  successfuldeal: 'Successful deal',
  faileddeal: 'Failed deal',
  convertedtodeal: 'Deal',
  convertedToDeal: 'Converted to deal',
  endChat: 'End chat',
  globalSearchPlaceholder:
    'Search person name & number, company name & number, ...',
  allCategories: 'All categories',
  searchResults: 'Search results',
  noResultsFound: 'No results found!',
  noResultsDescription: 'Check your search term or try a different one!',
  searchEncounteredAProblem: 'Search encountered a problem!',
  pleaseTryAgain: 'Please try again!',
  system: 'System',
  payment: 'Payment',
  enteredCodeIsIncorrect: 'Entered code is incorrect',
  versionNameIfAvailable: 'Version name(if available)',
  deductReason: 'output reason',
  deductDate: 'deduct date',
  DAMAGED: 'damaged',
  EXPIRED: 'expired',
  INVENTORY_SHORTAGE: 'inventory shortage',
  THEFT: 'theft',
  INTERNAL_USE: 'internal use',
  SUPPLIER_RETURN: 'supplier return',
  INVENTORY_CORRECTION: 'inventory correction',
  UNINOVICED_SALE: 'uninoviced sale',
  deductProductFromInventory: 'Remove Stock',
  deductProductFromInventoryConfirm:
    'Are you sure you want to remove these items from the warehouse?',
  notEnoughStock: 'Product Stock Not Enough',
  productQuantity: 'Product Quantity',
  increased: 'Increased',
  addedToInventory: 'Added To Inventory',
  enterApiToConnectProviders:
    'To connect with other software applications, register the required API.',
  apiDeactivationConfirm: 'Are you sure to {action} api gateway {apiProvider}',
  deactivationConfirmBtn: 'yes,deactivate',
  searchByTicketNumberAndTitle: 'Search ticket number and title',
  sendTicket: 'Send ticket',
  latestResponse: 'Latest response',
};
